import React from 'react'
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { useEffect, useState, useContext } from 'react'
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { FaMoon } from 'react-icons/fa';
import { BookingsContext } from './BookingContext';
import styles from "./style.module.css"
import { ButtonCustom } from '../../../BootstrapComponents/ButtonCustom';
import { toast } from 'react-toastify';
import { FaInfoCircle } from "react-icons/fa";
import { TbEyeDollar } from "react-icons/tb";
import { CgUnavailable } from "react-icons/cg";
import { Flex, Radio } from 'antd';
import Animations from '../../../Animations/Animations';
import { FaChargingStation } from 'react-icons/fa6';

import { useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Helper from '../../../Utils/Helper';
import StripePayment from '../../../StripePayment/StripePayment';
import { Modal, Checkbox } from 'antd';
import HourMinuteSelector from '../../../BookingHistory/components/BookingExtension/components/HourMinuteSelector';
import PhoneVerificationModal from '../../../RegistrationCommponents/PhoneVerificationModal';
import GuestBookingPayment from '../../../StripePayment/GuestBookingPayment';
import { loadUser } from '../../../Actions/Auth';
import store from '../../../store';
// import TooltipView from '../AdminDashboard/TooltipView'
import { Tooltip } from 'antd';

const BookingForm = ({ user, userID, userGroups, usersFreeChargingLocations, location, balance, selectedLocation, handleNewBooking, selectedTime, makeToast, costPerMinute, isUserTester, isAutoPayEnabled, timeFormatAmPm, extraTimeList, setExtraTimeList, quickStart, locationData, bookedSlots, selectedChargerForNonRes = null, isPhoneVerified, phone, availableNightCharging, userAvgPower, userPreferredConnector, isGuest }) => {
  // console.log("preferred connector for user: ", userPreferredConnector?.l2)
  // console.log("selected time from userdashboard to booking form: ", selectedTime)
  // console.log("locationDAta",locationData)
  // console.log("booked slots from dash to form : ", bookedSlots)
  // console.log("Phone",phone, isPhoneVerified)
  // console.log("location in bform: ", location, selectedLocation)  
  const [isBookingNonRes, setIsBookingNonRes] = useState(selectedChargerForNonRes ? (selectedChargerForNonRes.nonReservable ? true : false) : false)
  const [phoneState, setPhoneState] = useState(phone)
  const [isPhoneVerifiedState, setIsPhoneVerifiedstate] = useState(isPhoneVerified)
  const [guestPaymentBooking, setGuestPaymentBooking] = useState(null)

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const { isLoading, isAuthenticated } = useSelector(state => state.auth)
  const [chargers, setChargers] = useState([]);
  const [connectors, setConnectors] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [availableChargers, setAvailableChargers] = useState([]);
  const [availableConnectors, setAvailableConnectors] = useState([]);
  const [availableFreeChargers, setAvailableFreeChargers] = useState([]);
  const [selectedCharger, setSelectedCharger] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState("");
  const [doesUserInput, setDoesUserInput] = useState(false);
  const [durationReFill, setDurationReFill] = useState(0);

  const [showNightChargeOption, setShowNightChargeOption] = useState(false)
  const [isNightCharging, setIsNightCharging] = useState(false)
  const [isNightChargingPossible, setIsNightChargingPossible] = useState(false)
  const [showExtraDurationForNightCharge, setShowExtraDurationForNightCharge] = useState(0)
  const [doesBookingEndExceedNightEnd, setDoesBookingEndExceedNightEnd] = useState(false)
  const [nightChargingEstimate, setNightChargingEstimate] = useState(0);
  const [estimateSplit, setEstimateSplit] = useState('')

  const [startInstantly, setStartInstantly] = useState(false);
  const [instantTime, setInstantTime] = useState(null);

  const [showDifferentTypeConnectorSelected, setShowDifferentTypeConnectorSelected] = useState(false)

  // const [extraTimeList, setExtraTimeList] = useState([]);
  const [startTimeDisplay, setStartTimeDisplay] = useState('');
  const [startTimeDisplayChargerTime, setStartTimeDisplayChargerTime] = useState('');
  const [startDateDisplayChargerTime, setStartDateDisplayChargerTime] = useState('');
  const [endTimeDisplay, setEndTimeDisplay] = useState('');
  const [endTimeDisplayChargerTime, setEndTimeDisplayChargerTime] = useState('');
  const [defaultBookingDuration, setDefaultBookingDuration] = useState(0);
  const [isNightChargingAllowedInLocation, setIsNightChargingAllowedInLocation] = useState(selectedLocation && locationData.length > 0 ?
    (locationData.find(loc => loc._id === selectedLocation)?.overNightChargingEnabled || false)
    : false);
  const [idleFee, setIdleFee] = useState(selectedLocation && locationData.length > 0 ?
    locationData.map(loc => loc._id === selectedLocation ? loc.idleFee : 0)
    : 0);

  const [trigger, setTrigger] = useState(false);

  const [moreInfo, setMoreInfo] = useState(false);

  // const [isFreeBooking, setFreeBooking] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [lockedAmount, setLockedAmout] = useState(null);

  const { bookingsData, refetchBookings, isBookingLoading, chargersData, connectorData } = useContext(BookingsContext);
  // console.log("connectorData data from context: ", connectorData)

  const [currentTimeOne, setCurrentTimeOne] = useState(new Date());

  const [bookingSlotAvailability, setBookingSlotAvailability] = useState(true)

  const [minimumBalanceAvailable, setMinimumBalanceAvailable] = useState(true)

  const [renderTickMark, setRenderTickMark] = useState(false)

  const [estimateAmount, setEstimateAmount] = useState(0);

  const [dynamicRanges, sestDynamicRanges] = useState([]);

  const [rateType, setRateType] = useState("fixed")
  const [connectorAvailabilityArrayState, setConnectorAvailabilityArrayState] = useState([])
  const [normalRate, setNormalRate] = useState(0)

  const [isFreeChargingForSelectedLocation, setIsFreeChargingForSelectedLocation] = useState(false)
  const [isCustomEnergyRateForSelectedLocation, setIsCustomEnergyRateForSelectedLocation] = useState(false)
  const [customEnergyRate, setCustomEnergyRate] = useState(0)

  const [bookingSlotConflictShared, setBookingSlotConflictShared] = useState(false)

  const [nonResBookingDuration, setNonResBookingDuration] = useState(locationData[0].maxChargeDuration)
  const [nonResBookingAllowed, setNonResBookingAllowed] = useState(false)
  const [chargerSelection, setChargerSelection] = useState(locationData[0]?.selectCharger)

  const [walletRechargeModal, setWalletRechargeModal] = useState(false);
  const [amountToAdd, setAmountToAdd] = useState(10)
  const [phoneInputnModal, setPhoneInputModal] = useState(false)
  const [showPhoneVerificationModal, setShowPhoneVerificationModal] = useState(false)

  const [availableConnectorsInSelectedDurationState, setavailableConnectorsInSelectedDurationState] = useState([])

  const [bookingAllocationAlgorithm, setBookingAllocationAlgorithm] = useState(null)
  // function isFreeChargingAllowedInSelectedLocation(locationsFromPermission = []) {

  //   if (usersFreeChargingLocations.includes(selectedLocation)) {

  //     return true
  //   }
  //   if (locationsFromPermission.includes(selectedLocation)) {
  //     return true
  //   }
  //   // }
  //   if (usersFreeChargingLocations.length === 0 && locationsFromPermission.length === 0) {
  //     return true
  //   }
  //   return false;
  // }

  // function isCustomEnergyRateEnabledInSelectedLocation(customEnergyRateEnabledLocations = null) {
  //   try {
  //     if (customEnergyRateEnabledLocations) {
  //       if (customEnergyRateEnabledLocations.length === 0) {
  //         return true
  //       } else {
  //         if (customEnergyRateEnabledLocations.includes(selectedLocation)) {
  //           return true
  //         } else {
  //           return false
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error.message)
  //   }

  useEffect(() => {
    setIdleFee(selectedLocation && locationData.length > 0 ?
      locationData.map(loc => loc._id === selectedLocation ? loc.idleFee : 0)
      : 0)
  }, [selectedLocation])
  // }
  useEffect(() => {
    // isFreeCharging: isFreeCharging,
    //     customEnergyRate: customEnergyRate,
    //     isCustomEnergyRateForSelectedLocation: isCustomEnergyRateForSelectedLocation
    let { isFreeCharging, customEnergyRate, isCustomEnergyRateForSelectedLocation } = Helper.checkUserGroupPermissions(userGroups, selectedLocation, usersFreeChargingLocations)
    setIsFreeChargingForSelectedLocation(isFreeCharging)
    setIsCustomEnergyRateForSelectedLocation(isCustomEnergyRateForSelectedLocation)
    setCustomEnergyRate(customEnergyRate)

    // setIsFreeChargingForSelectedLocation(false)
    // try {
    //   userGroups.filter((userGroup) => {
    //     try {

    //       let parsedPermissions = JSON.parse(userGroup.permissions)

    //       try {
    //         if (parsedPermissions?.freeCharging && parsedPermissions?.freeCharging === 'allowed') {
    //           let isFreeCharging;

    //           if ("freeChargingAllowedLocations" in parsedPermissions) {
    //             isFreeCharging = Helper.isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations, usersFreeChargingLocations, selectedLocation) //isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations)
    //           } else {
    //             isFreeCharging = Helper.isFreeChargingAllowedInSelectedLocation()
    //           }
    //           isFreeCharging ? setIsFreeChargingForSelectedLocation(true) : setIsFreeChargingForSelectedLocation(false)

    //         }
    //       } catch (error) {
    //         console.log(error.message)
    //       }

    //       try {
    //         if (parsedPermissions?.customEnergyRate && parsedPermissions?.customEnergyRate === 'enabled') {
    //           let isCustomEnergyRateEnabled = false
    //           if ("customEnergyRateEnabledLocations" in parsedPermissions) {
    //             isCustomEnergyRateEnabled = isCustomEnergyRateEnabledInSelectedLocation(parsedPermissions.customEnergyRateEnabledLocations)
    //           } else {
    //             isCustomEnergyRateEnabled = true
    //           }


    //           if (isCustomEnergyRateEnabled) {
    //             setIsCustomEnergyRateForSelectedLocation(true)
    //             setCustomEnergyRate(parsedPermissions?.customEnergyRateEnabledRate)
    //           } else {
    //             setIsCustomEnergyRateForSelectedLocation(false)
    //             setCustomEnergyRate(0)
    //           }
    //         }

    //       } catch (error) {
    //         console.log(error.message)
    //       }


    //     } catch (error) {
    //       console.log(error.message)
    //     }

    //   })
    // } catch (error) {
    //   console.log(error.message)
    // }

  }, [duration, startTime])

  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const locationTimezone = locationData[0]?.timezone;;
  const [showChargerTime, setShowChargerTime] = useState(false);


  useEffect(() => {
    if (duration && duration !== null && duration !== "") {
      setMinimumBalanceAvailable(checkMinimumBalance(lockedAmount))
    }
    // console.log("duration in useEffect: ", duration)
    // console.log("night charging in useEffect : ", isNightCharging)
  }, [isNightCharging, balance])

  useEffect(() => {
    let offset = getTimeZoneOffsetTwoTimezone(localTimezone, locationTimezone)
    if (offset !== 0) {
      setShowChargerTime(true);
    }
    else {
      setShowChargerTime(false)
    }
  }, [locationTimezone]);

  function getTimeZoneOffsetTwoTimezone(timeZone1, timeZone2, date = new Date()) {
    // Create a date object for both time zones
    const dateInTimeZone1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
    const dateInTimeZone2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
    // Get the difference in time in milliseconds
    const timeDifferenceInMilliseconds = dateInTimeZone2.getTime() - dateInTimeZone1.getTime();

    return timeDifferenceInMilliseconds;
  }

  // let startDateTime = new Date(startDate + "T" + startTime);
  useEffect(() => {
    // console.log("variables in selectedCharger change: ", duration, selectedCharger, endDateTime)
    if (duration && selectedCharger) {

       let usedConnectors = checkSlotAvailable(true, false) 
        if(usedConnectors.length > 0){
         let isUsed = usedConnectors.some(
          (usedConnectorItem) => usedConnectorItem._id.toString() === selectedCharger.toString()
        );
        if (isUsed) {
           setBookingSlotConflictShared(true)
          // setSelectedCharger("");
        }else{
          setBookingSlotConflictShared(false)
        }
        }


      let selectedTimeInChargerTZ = new Date(selectedTime.toLocaleString('en-US', { timeZone: locationTimezone }));
      // console.log("selectedTimeInChargerTZ: ", selectedTimeInChargerTZ)
      let offset = selectedTimeInChargerTZ.getTime() - selectedTime.getTime();
      let durationToNegate = durationReFill;
      let newStartTimeInChargerTZ = new Date(selectedTimeInChargerTZ.getTime() - (durationToNegate * 60 * 1000));
      // console.log("new start time in charger timezone; ", newStartTimeInChargerTZ)
      let nightChargeEndTime;

      if (newStartTimeInChargerTZ.getHours() >= 9 && newStartTimeInChargerTZ.getHours() <= 23) {
        nightChargeEndTime = new Date(new Date(newStartTimeInChargerTZ.getTime() + 24 * 60 * 60 * 1000).setHours(9, 0, 0, 0));
      }
      else {
        nightChargeEndTime = new Date(newStartTimeInChargerTZ.setHours(9, 0, 0, 0));
      }
      // console.log("night chargerEndTime: ", nightChargeEndTime)
      // console.log("offset : ", offset)
      let nightChargeEndTimeInLocalTZ = new Date(nightChargeEndTime.getTime() - offset);
      let nightChargeStartTimeInLocalTZ = new Date(new Date(nightChargeEndTimeInLocalTZ).getTime() - (12 * 60 * 60 * 1000))
      let { nightChargingPossibleWithoutDuration, isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector } = checkNightCharging(availableConnectorsInSelectedDurationState, nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, availableConnectorsInSelectedDurationState.filter(con => con.connectorID == selectedCharger)[0])
      // setSelectedCharger(availableConnectorsInSelectedDuration[0].connectorID);
      if (nightChargingPossibleWithoutDuration === false) {
        setIsNightChargingPossible(false)
        setIsNightCharging(false)
      } else {
        (isNightChargingAvailable && nightChargingConnector != null && doesBookingEndExceedNightEndVar == false) ? setIsNightCharging(true) : setIsNightCharging(false)
        setIsNightChargingPossible(true)

        // isNightChargingAvailable ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
        // possibility of night charging 
        // cause wallet -> night connector available & isNightChargingAvailable false & nightCahrgingPossible without duration true
      }





      // let returnVal = calculateEstimatedAmount();
      // console.log("chargers",chargers)
      // console.log(startTime,startDate)
      let sdtime = new Date(startDate + "T" + startTime)
      // console.log("sdtime",sdtime)
      let returnVal = Helper.calculateEstimatedAmount(duration, sdtime, endDateTime, selectedCharger, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, null, userAvgPower, isNightCharging, locationData[0]?.gracePeriodInMinutes ?? 10);
      // console.log("Return val", returnVal)
      // console.log("rate split from estimate: ", returnVal.rateSplit)
      setEstimateSplit(returnVal.rateSplit)
      isFreeChargingForSelectedLocation ? setEstimateAmount(0) : setEstimateAmount(returnVal.estimateAmount)
      isCustomEnergyRateForSelectedLocation ? sestDynamicRanges([]) : sestDynamicRanges(returnVal.applicableDynamicRanges);
      setRateType(returnVal.rateType);
      setNormalRate(returnVal.normalRate)
    } else {
      // console.log("No valid duration or charger selected")
    }
  }, [duration, selectedCharger, durationReFill, startTime])

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      if (now.getMinutes() !== currentTimeOne.getMinutes()) {
        setCurrentTimeOne(now);
        if (startInstantly || durationReFill > 0) {
          setIsNightCharging(false)
          setIsNightChargingPossible(false)
          setNightChargingEstimate(0)
          setDoesBookingEndExceedNightEnd(false)
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentTimeOne]);


  const handleMakeToast = (type, text) => {
    if (makeToast) {
      makeToast(type, text);
    }
  };



  useEffect(() => {

    // Convert selectedTime to local time
    const localSelectedTime = new Date(selectedTime);
    // console.log("localselectedTime: ", localSelectedTime)

    localSelectedTime.setMinutes(localSelectedTime.getMinutes() - durationReFill)

    // Getting local date and time when selectedTime changes
    const year = localSelectedTime.getFullYear();
    const month = String(localSelectedTime.getMonth() + 1).padStart(2, '0');
    const day = String(localSelectedTime.getDate()).padStart(2, '0');
    const hour = String(localSelectedTime.getHours()).padStart(2, '0');
    const minute = String(localSelectedTime.getMinutes()).padStart(2, '0');
    const second = String(localSelectedTime.getSeconds()).padStart(2, '0');

    // Formatted date and time strings
    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hour}:${minute}:${second}`;
    setStartDate(formattedDate);
    setStartTime(formattedTime);
    setEndTimeDisplay(getEndTime());
    const startTimeDate = new Date(`${formattedDate}T${startTime}`);
    const formattedStartTime = startTimeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
    setStartTimeDisplay(formattedStartTime)
    if (showChargerTime) {
      const formattedStartTimeChargerTime = startTimeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm, timeZone: locationTimezone });

      setStartTimeDisplayChargerTime(formattedStartTimeChargerTime)

      setStartDateDisplayChargerTime(
        new Date(`${formattedDate} ${formattedTime}`).toLocaleString('en-US', {
          day: 'numeric',
          month: 'short', // Displays abbreviated month (e.g., Jan, Feb)
          year: 'numeric',

          timeZone: locationTimezone // Use the specific timezone
        })
      );
      setEndTimeDisplayChargerTime(getEndTime(locationTimezone))
    }

  }, [selectedTime, startTime, durationReFill, duration]);

  useEffect(() => {
    setDuration("");
    setSelectedCharger("");
    setAvailableChargers([]);
    setAvailableConnectors([]);
    setAvailableFreeChargers([]);
    setDurationReFill(0);
    setStartInstantly(quickStart);
    setBookingSlotAvailability(true)
    setBookingSlotConflictShared(false)
  }, [selectedTime]);



  useEffect(() => {
    setSelectedCharger("");
  }, [trigger])

  useEffect(() => {
    const filteredChargers = chargersData.filter(charger => !charger.nonReservable);
    const filteredConnectors = connectorData.filter(connector => !connector.nonReservable);
    setChargers(chargersData);
    setConnectors(filteredConnectors);
  }, [chargersData]);



  useEffect(() => {
    const filteredBookings = bookingsData.filter(booking => !booking.charger?.charger?.nonReservable);
    setBookings(filteredBookings);
    getLockedAmount();
  }, [bookingsData]);



  const getLockedAmount = async () => {
    try {
      const lockedAmt = await BreathAPIs.getTotalFutureEstimate();
      setLockedAmout(lockedAmt.data)
    } catch (error) {
      console.log("... ")
    }

  }

  const getEndTimeForNightCharge = (timezone = null) => {
    const durationAsInt = parseInt(duration, 10);

    if (isNaN(durationAsInt)) {
      return "";
    }

    const localSelectedTime = new Date(new Date(selectedTime).toLocaleString('en-US', { timeZone: timezone ? timezone : undefined }));
    const localPrevSelectedTime = new Date(new Date(selectedTime).toLocaleString('en-US', { timeZone: timezone ? timezone : undefined }));

    localSelectedTime.setMinutes(localSelectedTime.getMinutes() + durationAsInt + 10);
    const endTimeString = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: timeFormatAmPm,
    }).format(localSelectedTime);

    const dayIs = localSelectedTime.getDate() > localPrevSelectedTime.getDate() ? ' (+1)' : '';

    return `${endTimeString}`;
  };

  const getEndTime = (timezone = null) => {
    const durationAsInt = parseInt(duration, 10);

    if (isNaN(durationAsInt)) {
      return "";
    }

    const localSelectedTime = new Date(new Date(selectedTime).toLocaleString('en-US', { timeZone: timezone ? timezone : undefined }));
    const localPrevSelectedTime = new Date(new Date(selectedTime).toLocaleString('en-US', { timeZone: timezone ? timezone : undefined }));

    localSelectedTime.setMinutes(localSelectedTime.getMinutes() + durationAsInt);
    const endTimeString = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: timeFormatAmPm,
    }).format(localSelectedTime);

    const dayIs = localSelectedTime.getDate() > localPrevSelectedTime.getDate() ? ' (+1)' : '';

    return `${'- '}${endTimeString}${dayIs}`;
  };





  // Combine date and time
  let startDateTime = new Date(startDate + "T" + startTime);
  // const costPerMinute = 4.2;
  // Calculate end time
  const endDateTime = new Date(startDateTime);
  const totalMinutesForDuration = (parseFloat(duration, 10)); // Convert duration to minutes
  const hoursToAdd = Math.floor(totalMinutesForDuration / 60); // Whole hours
  const minutesToAdd = totalMinutesForDuration % 60; // Remaining minutes

  endDateTime.setHours(endDateTime.getHours() + hoursToAdd);
  endDateTime.setMinutes((endDateTime.getMinutes() + parseFloat(durationReFill, 10)) + minutesToAdd);


  // function convertToChargerTimeZone(utcDate, timeZone) {
  //   // Ensure utcDate is a Date object
  //   const date = new Date(utcDate);

  //   // Use Intl.DateTimeFormat to convert the date to the specified time zone
  //   const options = {
  //     timeZone: timeZone,
  //     hour12: false, // 24-hour format
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     second: '2-digit',
  //   };

  //   const formatter = new Intl.DateTimeFormat('en-US', options);
  //   const parts = formatter.formatToParts(date);

  //   // Extracting the individual date/time components
  //   const result = {};
  //   parts.forEach(({ type, value }) => {
  //     result[type] = value;
  //   });

  //   // Ensure the format is compatible with Date constructor (YYYY-MM-DDTHH:mm:ss)
  //   const formattedDate = `${result.year}-${result.month}-${result.day}T${result.hour}:${result.minute}:${result.second}`;

  //   // Return the new Date object in the specified time zone
  //   return new Date(formattedDate);
  // }
  // function getTargetZoneOffset(timeZone, date = new Date()) {
  //   try {


  //     const formatter = new Intl.DateTimeFormat('en-US', {
  //       timeZone,
  //       hour12: false,
  //       year: 'numeric',
  //       month: '2-digit',
  //       day: '2-digit',
  //       hour: '2-digit',
  //       minute: '2-digit',
  //       second: '2-digit'
  //     });

  //     const parts = formatter.formatToParts(date);
  //     const hourPart = parts.find(part => part.type === 'hour');
  //     const minutePart = parts.find(part => part.type === 'minute');

  //     const hour = parseInt(hourPart.value, 10);
  //     const minute = parseInt(minutePart.value, 10);

  //     // Get UTC time
  //     const utcHour = date.getUTCHours();
  //     const utcMinute = date.getUTCMinutes();

  //     const hourOffset = hour - utcHour;
  //     const minuteOffset = minute - utcMinute;

  //     return (hourOffset * 60) + minuteOffset; // Offset in minutes
  //   } catch (e) {
  //     console.error('Failed to calculate timezone offset:', e);
  //     return 0;
  //   }
  // }


  // const convertToTimezone = (timeString, timezone, dateFactor) => {
  //   const [startTime, endTime] = timeString.split('-');

  //   const convertTime = (time, timeZone) => {
  //     const [hours, minutes, seconds] = time.split(':');
  //     let date = new Date(dateFactor);
  //     let dateFactorDate = date.getDate();

  //     date.setHours(hours, minutes, seconds, 0);

  //     let offset = getTargetZoneOffset(timezone, date)
  //     date = new Date(date.getTime() + (offset * 60 * 1000))
  //     date.setDate(dateFactorDate)

  //     return date;
  //   };

  //   let startDateInTimezone = convertTime(startTime);
  //   let endDateInTimezone = convertTime(endTime);

  //   return { rangeStart: startDateInTimezone, rangeEnd: endDateInTimezone };
  // };

  // const bookingDurationCalculation = (startDateTimeCompensated, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin) => {
  //   let dynamicTime = 0;
  //   let estimateAmount = 0;

  //   //condition 1 - rangeStart<startDateTime<rangeEnd && rangeStart < endDateTime > rangeEnd // span over start time
  //   if (rangeStart <= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated >= rangeEnd) {
  //     dynamicTime = (new Date(rangeEnd) - new Date(startDateTimeCompensated)) / (1000 * 60);
  //     estimateAmount = (costPerMin * dynamicTime)
  //   }
  //   //condtion 2 - rangeStart > startDateTime < rangeEnd && rangeStart < endDateTime < rangeEnd // span over end time
  //   else if (rangeStart >= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
  //     dynamicTime = (new Date(endDateTimeCompensated) - new Date(rangeStart)) / (1000 * 60);
  //     estimateAmount = (costPerMin * dynamicTime)
  //   }
  //   //condition 3 - rangeStart > startDateTime < rangeEnd && rangeStart < endDateTime > rangeEnd // range within start and end
  //   else if (rangeStart >= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated >= rangeEnd) {
  //     dynamicTime = (new Date(rangeEnd) - new Date(rangeStart)) / (1000 * 60);
  //     estimateAmount = (costPerMin * dynamicTime)
  //   }

  //   else {
  //
  //   }

  //   return { calcEstimateAmount: estimateAmount, calcDynamicTime: dynamicTime }
  // }

  // const dynamicRangeFreeSlotCheck = (range1, range2, applicableDynamicRange, range1Index, range2Index) => {

  //   let updatedTimeRange = '';
  //   let rangeFree = null;
  //   let rangePaid = null;
  //   let index = null;
  //   let applicableRangesModified = applicableDynamicRange;
  //   if (range1.freeCharging === true && range2.freeCharging === true) {
  //     return applicableRangesModified
  //   }
  //   if (range1.freeCharging === true) {
  //     rangeFree = range1.timeRange
  //     rangePaid = range2.timeRange
  //     index = range2Index;
  //   } else if (range2.freeCharging === true) {
  //     rangeFree = range2.timeRange
  //     rangePaid = range1.timeRange
  //     index = range1Index;
  //   } else {
  //     return applicableRangesModified
  //   }
  //   let [rfStart, rfEnd] = rangeFree.split("-")
  //   let [rpStart, rpEnd] = rangePaid.split("-")
  //   const convertTime = (time) => {
  //     const [hours, minutes, secondsWithMillis] = time.split(':');
  //     const [seconds, milliseconds] = secondsWithMillis.split('.');
  //     let date = new Date();
  //     date.setHours(hours, minutes, seconds, milliseconds);
  //     return date;
  //   };
  //   rfStart = convertTime(rfStart);
  //   rfEnd = convertTime(rfEnd);
  //   rpStart = convertTime(rpStart);
  //   rpEnd = convertTime(rpEnd);
  //   if (rfEnd <= rfStart) {
  //     rfEnd.setDate(rfEnd.getDate() + 1)
  //   }
  //   if (rpEnd <= rpStart) {
  //     rpEnd.setDate(rpEnd.getDate() + 1)
  //   }

  //   if ((rpStart <= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd <= rfEnd)) {
  //     //Span over free time start Action - paid slot end time = free slot start time - 1 ms
  //     rpEnd = new Date(rfStart.getTime() - 1)
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpEnd)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;

  //   } else if ((rpStart >= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd >= rfEnd)) {
  //     // Span over free end time - Action  - paid slot start time = free end time + 1
  //     rpStart = new Date(rfEnd.getTime() + 1)
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpEnd)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;

  //   } else if ((rpStart >= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd <= rfEnd)) {
  //     //Paid slot within free slot - Action Remove paid slot 
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpStart)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;
  //     applicableRangesModified[index].rate = 0

  //   } else if ((rpStart <= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd >= rfEnd)) {
  //     //Free slot within paid slot Action - Split into two slots - 1) rpStart - rfStart-1 - 2) rfEnd+1 - rpEnd
  //     let tempStart = rpStart;
  //     let tempEnd = rpEnd;
  //     let tempSlot = { ...applicableRangesModified[index] }
  //     // slot 1
  //     rpEnd = new Date(rfStart.getTime() - 1)
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpEnd)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;
  //     //slot 2
  //     tempStart = new Date(rfEnd.getTime() + 1);
  //     updatedTimeRange = `${convertToTimeString(tempStart)}-${convertToTimeString(tempEnd)}`
  //     tempSlot.timeRange = updatedTimeRange;
  //     applicableRangesModified.push(tempSlot)

  //   } else {
  //     
  //   }

  //   return applicableRangesModified
  // }

  // function convertToTimeString(timestamp) {
  //   let updatedDate = timestamp
  //   const utcHours = updatedDate.getHours().toString().padStart(2, '0');
  //   const utcMinutes = updatedDate.getMinutes().toString().padStart(2, '0');
  //   const utcSeconds = updatedDate.getSeconds().toString().padStart(2, '0');
  //   const utcMilliseconds = updatedDate.getMilliseconds().toString().padStart(3, '0');
  //   return `${utcHours}:${utcMinutes}:${utcSeconds}.${utcMilliseconds}`;
  // }

  // const calculateEstimatedAmount = (time = duration) => {


  //   let endDateTimeCompensated =  new Date(endDateTime);

  //   let startDateTimeCompensated =  new Date(startDateTime);

  //   endDateTimeCompensated = new Date(endDateTimeCompensated.setMinutes(endDateTimeCompensated.getMinutes() - 10))

  //   let estimateAmount = 0

  //   let costPerMin = 0

  //   let selectedChargerData = isBookingNonRes ? selectedChargerForNonRes : (selectedCharger ? chargers.filter((charger)=>{return charger._id === selectedCharger})[0] : chargers[0])


  //   let chargerEnergyRating = selectedCharger ? selectedChargerData.connector.power : parseFloat(chargers[0].connector.power)


  //   let rate = isCustomEnergyRateForSelectedLocation ? parseFloat(customEnergyRate) : ( selectedChargerData ? selectedChargerData.rate.price_components.price : 0)
  //   let taxPercent = selectedChargerData ? selectedChargerData.rate.price_components.tax : 0
  //   let dynamicTime = 0
  //   let normalRateDuration = (endDateTimeCompensated - startDateTimeCompensated) / (1000 * 60);

  //   if (selectedChargerData.rateType === "fixed" || isCustomEnergyRateForSelectedLocation) {
  //     costPerMin = (rate * chargerEnergyRating) / 60;
  //     estimateAmount = costPerMin * (((parseFloat(time, 10) + parseFloat(durationReFill, 10)) - 10));
  //     return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), normalRate: rate } // add tax
  //   }
  //   let timezone = locationData[0].timezone;
  //   startDateTimeCompensated = convertToChargerTimeZone(startDateTimeCompensated, timezone)
  //   endDateTimeCompensated = convertToChargerTimeZone(endDateTimeCompensated, timezone)
  //   let applicableDynamicRangesStart = [];
  //   let applicableDynamicRangesEnd = [];
  //   let applicableDynamicRangesCorrected = []; //TO adjust for free time slots

  //   let applicableDynamicRanges = selectedChargerData.dynamicRates.filter(
  //     (rate) => {
  //       return (rate.applicableDays[startDateTimeCompensated.getDay()] === 1 || rate.applicableDays[endDateTimeCompensated.getDay()] === 1)
  //     }
  //   )
  //   let newApplicableDynamicRanges = [];
  //   let applicableDynamicRangeCurrent = JSON.parse(JSON.stringify(applicableDynamicRanges)) //To create a copy of the existing array
  //   applicableDynamicRanges.length > 1 ?
  //     applicableDynamicRanges.forEach((range, index) => {
  //       for (let i = index + 1; i <= applicableDynamicRanges.length - 1; i++) {
  //         newApplicableDynamicRanges = dynamicRangeFreeSlotCheck(range, applicableDynamicRanges[i], applicableDynamicRangeCurrent, index, i)
  //       }

  //     }) : newApplicableDynamicRanges = JSON.parse(JSON.stringify(applicableDynamicRanges))

  //   newApplicableDynamicRanges.filter(
  //     (rate) => {
  //       if (rate.applicableDays[startDateTimeCompensated.getDay()] === 1) {
  //         applicableDynamicRangesStart.push(rate)
  //       }
  //       if (rate.applicableDays[endDateTimeCompensated.getDay()] === 1) {
  //         applicableDynamicRangesEnd.push(rate)
  //       }
  //       return (rate.applicableDays[startDateTimeCompensated.getDay()] === 1 || rate.applicableDays[endDateTimeCompensated.getDay()] === 1)
  //     }
  //   )

  //   if (startDateTimeCompensated.getDay() === endDateTimeCompensated.getDay()) {
  //     newApplicableDynamicRanges.forEach(element => {
  //       let { rangeStart, rangeEnd } = convertToTimezone(element.timeRange, timezone, startDateTimeCompensated);
  //       costPerMin = (element.rate * chargerEnergyRating) / 60;


  //       //condtion 4 - rangeStart <startDateTime < rangeEnd && rangeStart < endDateTime < rangeEnd  // range encompassing the start and end
  //       if (rangeStart <= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
  //         dynamicTime = (new Date(endDateTimeCompensated) - new Date(startDateTimeCompensated)) / (1000 * 60);
  //         estimateAmount = costPerMin * dynamicTime
  //         normalRateDuration = 0;
  //         return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), applicableDynamicRanges: applicableDynamicRanges, rateType: selectedChargerData.rateType, normalRate: rate }
  //       }

  //       let { calcEstimateAmount, calcDynamicTime } = bookingDurationCalculation(startDateTimeCompensated, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin)
  //       estimateAmount += calcEstimateAmount;
  //       normalRateDuration -= calcDynamicTime
  //     });
  //   }
  //   else {
  //     let result = null
  //     // Booking Span
  //     // Booking duration split into two startTime - startDateEndTime and endDateStartTIme - endTime
  //     // Booking part current day
  //     applicableDynamicRangesStart.forEach(element => {
  //       let { rangeStart, rangeEnd } = convertToTimezone(element.timeRange, timezone, startDateTimeCompensated);
  //       costPerMin = (element.rate * chargerEnergyRating) / 60;
  //       let startTimeDayEnd = new Date(new Date(startDateTimeCompensated).setHours(23, 59, 59, 999))
  //       result = bookingDurationCalculation(startDateTimeCompensated, startTimeDayEnd, rangeStart, rangeEnd, costPerMin)
  //       estimateAmount += result.calcEstimateAmount;
  //       normalRateDuration -= result.calcDynamicTime
  //     });

  //     //Booking part next day
  //     applicableDynamicRangesEnd.forEach(element => {
  //       let { rangeStart, rangeEnd } = convertToTimezone(element.timeRange, timezone, endDateTimeCompensated);
  //       costPerMin = (element.rate * chargerEnergyRating) / 60;
  //       let endTimeDayStart = new Date(new Date(endDateTimeCompensated).setHours(0, 0, 0, 0))
  //       result = bookingDurationCalculation(endTimeDayStart, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin)
  //       estimateAmount += result.calcEstimateAmount;
  //       normalRateDuration -= result.calcDynamicTime
  //     });
  //   }
  //   costPerMin = (rate * chargerEnergyRating) / 60;
  //   estimateAmount += costPerMin * normalRateDuration;
  //   return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), applicableDynamicRanges: applicableDynamicRanges, rateType: selectedChargerData.rateType, normalRate: rate }
  // }



  const formatDate = (dateString, type = "long") => {
    const date = new Date(dateString);
    const options = { day: 'numeric', month: type, year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }

  const checkSlotAvailable = (listUsedChargers, defaultCheck = false, maxAllowedDuration = 0) => {
    // default check == true => starttime, endtime invalid 
    //Filter bookings for the selected charger and date

    if (defaultCheck) {
      startInstantly ? startDateTime.setTime(startDateTime.getTime() + (durationReFill * 60 * 1000)) : startDateTime.setTime(startDateTime.getTime());
      endDateTime.setTime(new Date(startDateTime.getTime() + (maxAllowedDuration * 60 * 1000)).getTime());
      startInstantly ? startDateTime.setTime(startDateTime.getTime() - (durationReFill * 60 * 1000)) : startDateTime.setTime(startDateTime.getTime());
    }

    const existingBookings = bookings.filter(
      (b) =>
        (b.connector === selectedCharger || listUsedChargers) &&
        (
          (new Date(b.startTime) < endDateTime && new Date(b.endTime) > startDateTime) ||
          (new Date(b.endTime) > startDateTime && new Date(b.startTime) < endDateTime)
        )
    );
    let usedChargers = [];
    let usedConnectors = []
    let isConflictWithSharedTime = false
    bookedSlots.map((slots) => {
      // if(slots.id === selectedCharger){
      slots.bookedSlots.map((booking) => {
        if ((new Date(booking.start).getTime() <= startDateTime.getTime() && startDateTime.getTime() < new Date(booking.end).getTime()) ||
          (new Date(booking.start).getTime() < endDateTime.getTime() && endDateTime.getTime() <= new Date(booking.end).getTime()) ||
          (startDateTime.getTime() <= new Date(booking.start).getTime() && new Date(booking.end).getTime() <= endDateTime.getTime())) {
          // setBookingSlotConflictShared(true)
          // setBookingSlotConflictShared(true)
          isConflictWithSharedTime = true
          usedConnectors.push({ _id: slots.connectorID })
          usedChargers.push({ _id: slots.id })
        }
      })

    })
    for (let booking of existingBookings) {
      if (
        (new Date(booking.startTime).getTime() <= startDateTime.getTime() && startDateTime.getTime() < new Date(booking.endTime).getTime()) ||
        (new Date(booking.startTime).getTime() < endDateTime.getTime() && endDateTime.getTime() <= new Date(booking.endTime).getTime()) ||
        (startDateTime.getTime() <= new Date(booking.startTime).getTime() && new Date(booking.endTime).getTime() <= endDateTime.getTime())
      ) {
        if (listUsedChargers) {
          usedConnectors.push(booking.connector);
          usedChargers.push(booking.charger);
        }
        else {
          handleMakeToast("error", "Booking conflicts with an existing booking.");
          return false;
        }

      }
    }
    if (!isConflictWithSharedTime) {
      setBookingSlotConflictShared(false)
      // return usedChargers
    }
    if (listUsedChargers) {
      return usedConnectors;
    }
    else {
      return true;
    }
  }

  const checkPreviousSlotAvailable = () => {
    let usedChargers = [];

    const _15minBeforeSelected = new Date(selectedTime);
    _15minBeforeSelected.setMinutes(_15minBeforeSelected.getMinutes() - 15)

    for (let booking of bookings) {
      if (
        (new Date(booking.startTime).getTime() <= _15minBeforeSelected.getTime() && _15minBeforeSelected.getTime() < new Date(booking.endTime).getTime()) ||
        (new Date(booking.startTime).getTime() < endDateTime.getTime() && endDateTime.getTime() <= new Date(booking.endTime).getTime()) ||
        (_15minBeforeSelected.getTime() <= new Date(booking.startTime).getTime() && new Date(booking.endTime).getTime() <= endDateTime.getTime())
      ) {
        usedChargers.push(booking.charger);
      }
    }

    if (chargersData?.length > usedChargers?.length) {
      return true;
    }
    else {
      return false;
    }
  }

  function getTimesBetween(start, end, interval, AmPm = false) {
    let startTime = new Date(start);
    let endTime = new Date(end);
    let times = [];

    const currentTime = new Date();

    if (!(currentTime >= startTime && currentTime <= endTime)) {
      return times;
    }
    startTime.setMinutes(Math.floor(startTime.getMinutes() / interval) * interval);

    while (startTime < endTime) {
      if (currentTime < startTime) {
        times.push(formatTime(startTime, endTime, AmPm));
      }
      startTime.setMinutes(startTime.getMinutes() + interval);
    }

    times.push(formatTime(startTime, endTime, AmPm));
    return times;
  }

  function formatTime(date, endTime, AmPm = false) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let period = '';
    if (AmPm) {
      period = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
    }

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    // Calculate minutes from end time
    const diffMs = Math.abs(endTime - date);
    const diffMins = Math.floor(diffMs / 60000); // Calculate difference in minutes


    return { time: `${hours}:${minutes} ${period}`, diffMins };
  }

  function handleExtraTime() {
    const previousSlotAvailable = checkPreviousSlotAvailable();
    if (previousSlotAvailable) {
      const _15minBeforeSelected = new Date(selectedTime);
      _15minBeforeSelected.setMinutes(_15minBeforeSelected.getMinutes() - 15);
      const SelectedTime = new Date(selectedTime);
      const extraTimeListData = getTimesBetween(_15minBeforeSelected, SelectedTime, 5, timeFormatAmPm)
      setExtraTimeList(extraTimeListData);
      setDurationReFill(extraTimeListData.length ? (extraTimeListData.some(item => item.diffMins === durationReFill) ? durationReFill : 0) : 0);
    }
    else {
      setExtraTimeList([]);
      setDurationReFill(0);
    }
  }

  useEffect(() => {
    handleExtraTime();
    setInstantTime(formatTime(new Date(), new Date(selectedTime), timeFormatAmPm));
  }, [duration, currentTimeOne, selectedTime]);

  useEffect(() => {
    const handleDurationChange = () => {
      let durationWeight = 0.25
      let powerWeight = 0.25
      let energyWeight = 0.5
      // console.log("inside handle duration change:")
      // console.log("duration in handle duration change: ", duration)
      setShowExtraDurationForNightCharge(0)
      setBookingSlotConflictShared(false)
      // const usedChargers = checkSlotAvailabl e(true);
      // let chargersList = chargers.filter(
      //   charger => !usedChargers.some(usedCharger => usedCharger._id.toString() === charger._id)
      // );
      let usedConnector = checkSlotAvailable(true, false);
      let availableConnectors = []
      let usedConnectors = []
      connectors.forEach((connector) => {
        const isUsed = usedConnector.some(
          (usedConnectorItem) => usedConnectorItem._id.toString() === connector._id.toString()
        );
        if (!isUsed) {
          availableConnectors.push(connector);
        } else {
          usedConnectors.push(connector);
        }
      });

      let newFoundAvailableConnectors = [];

      availableConnectors.forEach((connector) => {

        let isConnectorExistsInAVailabilityArray = connectorAvailabilityArrayState.some(
          (availableConnector) => availableConnector.connectorID.toString() === connector._id.toString()
        );
        if (!isConnectorExistsInAVailabilityArray && doesUserInput) {
          let minimumBalanceAvailableForSelectedDuration = checkMinimumBalance(lockedAmount, (locationData[0].maxChargeDuration * 60), startInstantly, connector._id)

          if (!minimumBalanceAvailableForSelectedDuration) {

            for (let timeDuration = (locationData[0].maxAllowedDuration * 60); timeDuration >= (locationData[0]?.minChargeDuration * 60) ?? 15; timeDuration -= 15) {
              endDateTime.setTime(new Date(startDateTime.getTime() + ((timeDuration + durationReFill) * 60 * 1000)).getTime());

              let isMinimumBalanceCheckPassed = checkMinimumBalance(lockedAmount, timeDuration, startInstantly, connector._id)

              let removeConnector = true
              if (isMinimumBalanceCheckPassed) {
                newFoundAvailableConnectors.push({
                  connectorID: connector._id,
                  availableDuration: timeDuration,
                  power: connector.power,
                  utScore: connector.utilizationScore,
                  energyDelivered: ((timeDuration / 60) * connector.power),
                  allocationScore: (((timeDuration / 60) * connector.power) * energyWeight) + ((timeDuration / 60) * durationWeight) + (connector.power * powerWeight),
                  nightChargerPossible: false,
                  connectorType: connector.type
                })

                // connector.availableDuration = timeDuration
                // connector.energyDelivered = ((timeDuration / 60) * connector.power)
                // connector.allocationScore = (((timeDuration / 60) * connector.power) * energyWeight) + ((timeDuration / 60) * durationWeight) + (connector.power * powerWeight)
                removeConnector = false
                break
              }

            }
          } else {
            newFoundAvailableConnectors.push({
              connectorID: connector._id,
              availableDuration: (locationData[0].maxChargeDuration * 60),
              power: connector.power,
              utScore: connector.utilizationScore,
              energyDelivered: (((locationData[0].maxChargeDuration * 60) / 60) * connector.power),
              allocationScore: ((((locationData[0].maxChargeDuration * 60) / 60) * connector.power) * energyWeight) + ((locationData.maxAllowedDuration / 60) * durationWeight) + (connector.power * powerWeight),
              nightChargerPossible: false,
              connectorType: connector.type
            })
          }
        }

        //  connectorAvailabilityArray.push({
        //         connectorID: connector._id,
        //         availableDuration: maxAllowedDuration,
        //         power: connector.power,
        //         energyDelivered: ((maxAllowedDuration / 60) * connector.power),
        //         allocationScore: (((maxAllowedDuration / 60) * connector.power) * energyWeight) + ((maxAllowedDuration / 60) * durationWeight) + (connector.power * powerWeight),
        //         utScore: connector.utilizationScore
        //       })


      })

      // console.log("newFoundAvailableConnectors: ", newFoundAvailableConnectors)
      let existingAvailableConnectors = [...connectorAvailabilityArrayState, ...newFoundAvailableConnectors];




      // console.log("usedConnectors to remove from availability array: ", usedConnectors)
      // console.log("existingAvailableConnectors before removing used: ", existingAvailableConnectors)
      if (usedConnectors.length > 0) {
        usedConnectors.forEach((connector) => {
          existingAvailableConnectors = existingAvailableConnectors.filter(
            (availableConnector) => availableConnector.connectorID !== connector._id.toString()
          );
          // }
        });
      }
      // console.log("existingAvailableConnectors after removing used: ", existingAvailableConnectors)
      // setConnectorAvailabilityArrayState(existingAvailableConnectors);

      let availableConnectorsInSelectedDuration = existingAvailableConnectors.filter(
        connector => connector.availableDuration >= duration
      );



      let selectedTimeInChargerTZ = new Date(selectedTime.toLocaleString('en-US', { timeZone: locationTimezone }));
      // console.log("selectedTimeInChargerTZ: ", selectedTimeInChargerTZ)
      let offset = selectedTimeInChargerTZ.getTime() - selectedTime.getTime();
      let durationToNegate = durationReFill;
      let newStartTimeInChargerTZ = new Date(selectedTimeInChargerTZ.getTime() - (durationToNegate * 60 * 1000));
      // console.log("new start time in charger timezone; ", newStartTimeInChargerTZ)
      let nightChargeEndTime;

      if (newStartTimeInChargerTZ.getHours() >= 9 && newStartTimeInChargerTZ.getHours() <= 23) {
        nightChargeEndTime = new Date(new Date(newStartTimeInChargerTZ.getTime() + 24 * 60 * 60 * 1000).setHours(9, 0, 0, 0));
      }
      else {
        nightChargeEndTime = new Date(new Date(newStartTimeInChargerTZ).setHours(9, 0, 0, 0));
      }
      // console.log("night chargerEndTime: ", nightChargeEndTime)
      // console.log("offset : ", offset)
      let nightChargeEndTimeInLocalTZ = new Date(nightChargeEndTime.getTime() - offset);
      let nightChargeStartTimeInLocalTZ = new Date(new Date(nightChargeEndTimeInLocalTZ).getTime() - (12 * 60 * 60 * 1000))

      let endDateTimeTemp = new Date(endDateTime)
      let nightChargeSlotUsedConnectors = checkSlotAvailable(true, true, (nightChargeEndTimeInLocalTZ.getTime() - selectedTime.getTime()) > 0 ? (nightChargeEndTimeInLocalTZ.getTime() - selectedTime.getTime()) / (1000 * 60) : 0)
      // console.log("nightChargeSlotUsedConnectors: ", nightChargeSlotUsedConnectors)

      endDateTime.setTime(endDateTimeTemp.getTime())
      availableConnectorsInSelectedDuration.map((connector, index) => {

        if (nightChargeSlotUsedConnectors.some(usedconnector => usedconnector._id.toString() === connector.connectorID)) {
          availableConnectorsInSelectedDuration[index].nightChargerPossible = false
        } else {
          availableConnectorsInSelectedDuration[index].nightChargerPossible = true
        }
      })
      // console.log("availableConnectorsInSelectedDuration: ", availableConnectorsInSelectedDuration)







      if (availableConnectorsInSelectedDuration.length === 0) {
        console.log("inside if condition ; ")
        let usedConnectors = checkSlotAvailable(true, false) 
        if(usedConnectors.length > 0){
         let isUsed = usedConnectors.some(
          (usedConnectorItem) => usedConnectorItem._id.toString() === selectedCharger.toString()
        );
        if (isUsed) {
           setBookingSlotConflictShared(true)
          // setSelectedCharger("");
        }
        }
        //  setSelectedCharger("");
        
        if (duration !== "") {
          setBookingSlotAvailability(false)
        }
      } else {
        let availableChargerList = [];
        console.log("inside else condition ; ")


        chargers.forEach((charger) => {
          const hasMatchingConnector = charger.connector.some((connector) =>
            availableConnectorsInSelectedDuration.some(
              (connectorItem) =>
                connectorItem.connectorID === connector._id.toString()
            )
          );

          if (hasMatchingConnector && !availableChargerList.includes(charger)) {
            availableChargerList.push(charger);
          }
        });
        let availableConnectorList = connectors.filter(
          connector => availableConnectorsInSelectedDuration.some(availableConnector => availableConnector.connectorID === connector._id)
        );
        // console.log("available connectors list in duration change: ", availableConnectorList)


        setavailableConnectorsInSelectedDurationState(availableConnectorsInSelectedDuration)
        // console.log(
        //   "available connectors in selected duration: ", availableConnectorsInSelectedDuration
        // )
        if (availableConnectorsInSelectedDuration.length > 0) {


          // (nightChargingPossibleWithoutDuration && isNightChargingAvailable && nightChargingConnector !== null) ? setSelectedCharger(nightChargingConnector.connectorID) : 
          // setSelectedCharger(availableConnectorsInSelectedDuration[0].connectorID)
          //  let {nightChargingPossibleWithoutDuration,  isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector} = checkNightCharging(availableConnectorsInSelectedDuration, nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ)

          let doesConnectorExistInArray = availableConnectorsInSelectedDuration.some((connectorVal) => {
            return connectorVal.connectorID == selectedCharger
          })

          if ((availableConnectorsInSelectedDuration.length > 0 && !doesConnectorExistInArray)) {
            let { nightChargingPossibleWithoutDuration, isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector } = checkNightCharging(availableConnectorsInSelectedDuration, nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, null)
            // setSelectedCharger(availableConnectorsInSelectedDuration[0].connectorID);
            console.log("inside if condition in duration change")

            // console.log("nightChargingPossibleWithoutDuration: ", nightChargingPossibleWithoutDuration)
            // console.log("isNightChargingAvailable: ", isNightChargingAvailable)
            // console.log("doesBookingEndExceedNightEndVar: ", doesBookingEndExceedNightEndVar)
            // console.log("nightChargingConnector: ", nightChargingConnector)
            // console.log("duration: ", duration)

            if (duration < 180 && nightChargingPossibleWithoutDuration && !isNightChargingAvailable && nightChargingConnector !== null
              && doesBookingEndExceedNightEndVar == false &&
              ((newStartTimeInChargerTZ.getHours() >= 21 && newStartTimeInChargerTZ.getHours() <= 23)
                || (newStartTimeInChargerTZ.getHours() >= 0 && newStartTimeInChargerTZ.getHours() <= 5 &&
                  (newStartTimeInChargerTZ.getHours() === 5 ? newStartTimeInChargerTZ.getMinutes() <= 45 : true)))) {


              // console.log("inside if condition in duration change")

              //           if ((newStartTimeInChargerTZ.getHours() >= 21 && newStartTimeInChargerTZ.getHours() <= 23) 
              //             || (newStartTimeInChargerTZ.getHours() >= 0 && newStartTimeInChargerTZ.getHours() <= 5 && (newStartTimeInChargerTZ.getHours() === 5 ? newStartTimeInChargerTZ.getMinutes() <= 45 : true))) {
              //   setDefaultDurationToThreeHours = true
              // }
              // booking End Time (charger tz); <= 8.45 
              // let newBookingEndForNightCharge = new Date(newStartTimeInChargerTZ);
              // newBookingEndForNightCharge.setDate(newBookingEndForNightCharge.getDate() + 1);
              // console.log("newBookingEndForNightCharge: ", newBookingEndForNightCharge)
              // newBookingEndForNightCharge.setHours(0, 0, 0, 0);
              setShowExtraDurationForNightCharge(180)
            }
            if (nightChargingPossibleWithoutDuration && !isNightChargingAvailable && nightChargingConnector !== null && doesBookingEndExceedNightEndVar == false && (newStartTimeInChargerTZ.getHours() <= 20 && newStartTimeInChargerTZ.getHours() >= 9)) {
              // booking End Time (charger tz); <= 8.45 
              let newBookingEndForNightCharge = new Date(newStartTimeInChargerTZ);
              newBookingEndForNightCharge.setDate(newBookingEndForNightCharge.getDate() + 1);
              console.log("newBookingEndForNightCharge: ", newBookingEndForNightCharge)
              newBookingEndForNightCharge.setHours(0, 0, 0, 0);
              setShowExtraDurationForNightCharge((newBookingEndForNightCharge - newStartTimeInChargerTZ) / (1000 * 60))
            }
            // else{
            //   setShowExtraDurationForNightCharge(0)
            // }





            if (nightChargingPossibleWithoutDuration === false) {
              setIsNightChargingPossible(false)
              setIsNightCharging(false)
            } else {
              (isNightChargingAvailable && nightChargingConnector != null && doesBookingEndExceedNightEndVar == false) ? setIsNightCharging(true) : setIsNightCharging(false)
              setIsNightChargingPossible(true)
              // isNightChargingAvailable ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
              // possibility of night charging 
              // cause wallet -> night connector available & isNightChargingAvailable false & nightCahrgingPossible without duration true
            }
            (nightChargingPossibleWithoutDuration && isNightChargingAvailable && nightChargingConnector !== null) ? setSelectedCharger(((startInstantly || durationReFill>0 )) ? '' : nightChargingConnector.connectorID) :
              setSelectedCharger(((startInstantly || durationReFill>0 )) ? '' : availableConnectorsInSelectedDuration[0].connectorID)
          //&& !doesUserInput
            } else if (availableConnectorsInSelectedDuration.length == 0) {
            setSelectedCharger("")
            setShowExtraDurationForNightCharge(0)
          } else {
            console.log("inside else condition duration change; ")
            let { nightChargingPossibleWithoutDuration, isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector } = checkNightCharging(availableConnectorsInSelectedDuration, nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, availableConnectorsInSelectedDuration.filter(con => con.connectorID == selectedCharger)[0])

            // console.log("nightChargingPossibleWithoutDuration: ", nightChargingPossibleWithoutDuration)
            // console.log("isNightChargingAvailable: ", isNightChargingAvailable)
            // console.log("doesBookingEndExceedNightEndVar: ", doesBookingEndExceedNightEndVar)
            // console.log("nightChargingConnector: ", nightChargingConnector)
            // console.log("duration: ", duration)

            if (duration < 180 && nightChargingPossibleWithoutDuration && !isNightChargingAvailable && nightChargingConnector !== null
              && doesBookingEndExceedNightEndVar == false &&
              ((newStartTimeInChargerTZ.getHours() >= 21 && newStartTimeInChargerTZ.getHours() <= 23)
                || (newStartTimeInChargerTZ.getHours() >= 0 && newStartTimeInChargerTZ.getHours() <= 5 &&
                  (newStartTimeInChargerTZ.getHours() === 5 ? newStartTimeInChargerTZ.getMinutes() <= 45 : true)))) {




              //           if ((newStartTimeInChargerTZ.getHours() >= 21 && newStartTimeInChargerTZ.getHours() <= 23) 
              //             || (newStartTimeInChargerTZ.getHours() >= 0 && newStartTimeInChargerTZ.getHours() <= 5 && (newStartTimeInChargerTZ.getHours() === 5 ? newStartTimeInChargerTZ.getMinutes() <= 45 : true))) {
              //   setDefaultDurationToThreeHours = true
              // }
              // booking End Time (charger tz); <= 8.45 
              // let newBookingEndForNightCharge = new Date(newStartTimeInChargerTZ);
              // newBookingEndForNightCharge.setDate(newBookingEndForNightCharge.getDate() + 1);
              // console.log("newBookingEndForNightCharge: ", newBookingEndForNightCharge)
              // newBookingEndForNightCharge.setHours(0, 0, 0, 0);
              setShowExtraDurationForNightCharge(180)
            }
            if (nightChargingPossibleWithoutDuration && !isNightChargingAvailable && nightChargingConnector !== null && doesBookingEndExceedNightEndVar == false && (newStartTimeInChargerTZ.getHours() <= 20 && newStartTimeInChargerTZ.getHours() >= 9)) {
              // booking End Time (charger tz); <= 8.45 
              let newBookingEndForNightCharge = new Date(newStartTimeInChargerTZ);
              newBookingEndForNightCharge.setDate(newBookingEndForNightCharge.getDate() + 1);
              console.log("newBookingEndForNightCharge: ", newBookingEndForNightCharge)
              newBookingEndForNightCharge.setHours(0, 0, 0, 0);
              setShowExtraDurationForNightCharge((newBookingEndForNightCharge - newStartTimeInChargerTZ) / (1000 * 60))
            }
            // else{
            //   setShowExtraDurationForNightCharge(0)
            // }




            if (nightChargingPossibleWithoutDuration === false) {
              setIsNightChargingPossible(false)
              setIsNightCharging(false)
            } else {
              (isNightChargingAvailable && nightChargingConnector != null && doesBookingEndExceedNightEndVar == false) ? setIsNightCharging(true) : setIsNightCharging(false)
              setIsNightChargingPossible(true)
              // isNightChargingAvailable ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
              // possibility of night charging 
              // cause wallet -> night connector available & isNightChargingAvailable false & nightCahrgingPossible without duration true
            }
          }

          setAvailableChargers(availableChargerList);
          setAvailableConnectors(availableConnectorList)
          // setSelectedCharger(availableConnectorsInSelectedDuration[0].connectorID);
          // locationData[0].chargerAllocationConfiguration === 'Random' ? setSelectedCharger(getRandomChargerId(connectorList)) : setSelectedCharger(getSortedChargerId(connectorList));
          setBookingSlotAvailability(true)


        }

        else {
          console.log("inside else condition for available connectors in duration change; ")
          setSelectedCharger("")
        }
        // const usedConnectors = checkSlotAvailable(true);
        // let connectorList = connectors.filter(
        //   connector => !usedConnectors.some(usedconnector => usedconnector._id.toString() === connector._id)
        // );
        // // console.log("startInstantly",startInstantly)
        // // console.log("DurationReFill",durationReFill) 
        // if (startInstantly || durationReFill > 0) {
        //   connectorList = connectorList.filter(
        //     connector => connector.chargerStatus === "Online"
        //   )
        // }

        // // chargers.find((charger) => {charger.connector = connectorList.find((connector) => connector._id === charger.connector._id)})
        // // console.log("Charger list", chargersList)
        // let availableChargerList = [];

        // chargers.forEach((charger) => {
        //   const hasMatchingConnector = charger.connector.some((connector) =>
        //     connectorList.some(
        //       (connectorItem) =>
        //         connectorItem._id.toString() === connector._id.toString()
        //     )
        //   );

        //   if (hasMatchingConnector && !availableChargerList.includes(charger)) {
        //     availableChargerList.push(charger);
        //   }
        // });

        // console.log(
        //   "setting state for connector in handle duration change"
        // )
        // setAvailableChargers(availableChargerList);
        // setAvailableConnectors(connectorList)

        // // setAvailableConnectors(chargersList.map(charger => charger.connector));

        // // const availableFreeChargerList = chargersList.filter(
        // //   charger => charger.freeChargingComponent.isFreeCharging === true
        // // );

        // // setAvailableFreeChargers(availableFreeChargerList);

        // // const getRandomChargerId = (chargersArray) => {
        // //   const randomIndex = Math.floor(Math.random() * chargersArray.length);
        // //   return chargersArray[randomIndex]._id;
        // // }

        // // const getSortedChargerId = (chargersArray) => {
        // //   // Finding the charger with the least utilizationScore
        // //   const selectedCharger = chargersArray.reduce((prev, curr) => {
        // //     return (prev.utilizationScore < curr.utilizationScore) ? prev : curr;
        // //   });

        // //   return selectedCharger._id; // Returning the charger id with the least utilizationScore
        // // }


        // if (connectorList.length > 0) {
        //   locationData[0].chargerAllocationConfiguration === 'Random' ? setSelectedCharger(getRandomChargerId(connectorList)) : setSelectedCharger(getSortedChargerId(connectorList));
        //   setBookingSlotAvailability(true)
        // } else {
        //   setSelectedCharger("");
        //   if (duration !== "") {
        //     setBookingSlotAvailability(false)
        //   }
        // }
        // if (isBookingNonRes) {
        //   setSelectedCharger(selectedChargerForNonRes?.id)
        // }
      };
    }

    handleDurationChange();
    // if(duration < 180){
    //     setIsNightCharging(false)
    //   }

    duration && setMinimumBalanceAvailable(checkMinimumBalance(lockedAmount))


  }, [duration, startTime, startInstantly, estimateAmount, durationReFill]);

  useEffect(() => {

    setDurationReFill(startInstantly ? (startDateTime - new Date()) / (1000 * 60) : 0);
  }, [])

  useEffect(() => {
    // console.log("default duration set useeffect")
    //     { 

    // connectorID:

    // available duration: *max allowed duration initially*

    // Power: *from connector object*

    // EnergyDelivered:  *(available duration)  *  (Power)*

    // Allocation score: *EnergyDelivered * (wt1) + available duration * (wt2) + power * (wt3)*

    // Ut score:  *from connector object*

    // }
    const assignDefaultCharger = () => {
      // console.log("startinstantly: ", startInstantly, "duration refill:878787 ", durationReFill, (startInstantly && durationReFill > 0))
      // console.log("default charger assign called")

      // console.log("startinstant: ", startInstantly)
      // console.log("startTime: ", startDateTime)

      // console.log("available charger list state before default assignment: ", availableConnectorsInSelectedDurationState)

      let connectorAvailabilityArray = [];
      let durationWeight = 0.25
      let powerWeight = 0.25
      let energyWeight = 0.5
      let defaultMinimumBalanceAvailable = true
      let initialStartTime = new Date(startDateTime);

      let maxAllowedDuration = 0
      // console.log(connectors.length)
      for (let timeDuration = locationData[0].maxChargeDuration * 60; timeDuration >= (locationData[0]?.minChargeDuration * 60) ?? 15; timeDuration -= 15) {

        maxAllowedDuration = timeDuration
        const usedConnectors = checkSlotAvailable(true, true, maxAllowedDuration);
        startDateTime.setTime(new Date(initialStartTime.getTime()).getTime());
        // console.log("used connectors in default duration: ", usedConnectors)
        let connectorList = connectors.filter(
          connector => !usedConnectors.some(usedconnector => usedconnector._id.toString() === connector._id)
        );
        // console.log("timeDuration in default duration: ", timeDuration)
        // console.log("connectorList in default duration: ", connectorList)
        if (startInstantly || durationReFill > 0) {
          connectorList = connectorList.filter(
            connector => connector.chargerStatus === "Online"
          )
        }
        // console.log("time duration in check slot available default case: ", timeDuration)
        if (connectorList.length !== 0) {

          // console.log("connectorAvailabilityArray initial value", connectorAvailabilityArray)
          connectorList.forEach((connector) => {
            const exists = connectorAvailabilityArray.some(item => item.connectorID === connector._id);
            if (!exists) {
              // console.log("connector data update in available connector list")
              // console.log("max allowed duration: ", maxAllowedDuration)
              // console.log("array value before: ", connectorAvailabilityArray)
              connectorAvailabilityArray.push({
                connectorID: connector._id,
                availableDuration: maxAllowedDuration,
                power: connector.power,
                energyDelivered: ((maxAllowedDuration / 60) * connector.power),
                allocationScore: (((maxAllowedDuration / 60) * connector.power) * energyWeight) + ((maxAllowedDuration / 60) * durationWeight) + (connector.power * powerWeight),
                utScore: connector.utilizationScore,
                nightChargerPossible: false,
                connectorType: connector.type
              })
              // console.log("array value after: ", connectorAvailabilityArray)
            }
          })


        }

        if (connectorAvailabilityArray.length === connectors.length) {
          break
        }
      }
      // console.log("array value after: ", connectorAvailabilityArray)
      // console.log("start date time after first loop : ", startDateTime)
      startDateTime.setTime(new Date(startDateTime.getTime() - (durationReFill * 60 * 1000)).getTime());
      // console.log("connectorAvailabilityArray", connectorAvailabilityArray)
      // console.log("endtime after check availability: ", endDateTime)
      // console.log("duration refill ", durationReFill)  

      let selectedTimeInChargerTZ1 = new Date(selectedTime.toLocaleString('en-US', { timeZone: locationTimezone }));
      let offset1 = selectedTimeInChargerTZ1.getTime() - selectedTime.getTime();
      let newStartTimeInChargerTZ1 = new Date(selectedTimeInChargerTZ1.getTime() - (durationReFill * 60 * 1000));
      let nightChargeEndTime1;
      if (newStartTimeInChargerTZ1.getHours() >= 9 && newStartTimeInChargerTZ1.getHours() <= 23) {
        nightChargeEndTime1 = new Date(new Date(newStartTimeInChargerTZ1.getTime() + 24 * 60 * 60 * 1000).setHours(9, 0, 0, 0));
      } else {
        nightChargeEndTime1 = new Date(new Date(newStartTimeInChargerTZ1).setHours(9, 0, 0, 0));
      }
      let nightChargeEndTimeInLocalTZ1 = new Date(nightChargeEndTime1.getTime() - offset1);
      let nightChargeStartTimeInLocalTZ1 = new Date(new Date(nightChargeEndTimeInLocalTZ1).getTime() - (12 * 60 * 60 * 1000));
      let endDateTimeTemp1 = new Date(endDateTime);
      let nightChargeSlotUsedConnectors1 = checkSlotAvailable(true, true, (nightChargeEndTimeInLocalTZ1.getTime() - selectedTime.getTime()) > 0 ? (nightChargeEndTimeInLocalTZ1.getTime() - selectedTime.getTime()) / (1000 * 60) : 0);
      endDateTime.setTime(endDateTimeTemp1.getTime());
      connectorAvailabilityArray.forEach((connector, index) => {
        connectorAvailabilityArray[index].nightChargerPossible = !nightChargeSlotUsedConnectors1.some(usedconnector => usedconnector._id.toString() === connector.connectorID);
      });

      const isNightChargingForSlot = (timeDur, isNightChargerPossible) => {
        if (!isNightChargingAllowedInLocation || !isNightChargerPossible) return false;
        let bStart = startDateTime.getTime();
        let bEnd = startDateTime.getTime() + ((timeDur + durationReFill) * 60 * 1000);
        let nStart = nightChargeStartTimeInLocalTZ1.getTime();
        let nEnd = nightChargeEndTimeInLocalTZ1.getTime();
        if (bEnd >= nEnd) return false;
        if ((bStart <= nStart) && (bEnd > nStart) && (bEnd <= nEnd)) return ((bEnd - nStart) >= 180 * 60 * 1000);
        else if ((bStart >= nStart) && (bStart < nEnd) && (bEnd > nStart) && (bEnd <= nEnd)) return ((bEnd - bStart) >= 180 * 60 * 1000);
        return false;
      };

      let idsToRemove = []
      connectorAvailabilityArray.forEach((connector) => {
        // console.log("connector: ", connector)
        endDateTime.setTime(new Date(startDateTime.getTime() + ((connector.availableDuration + durationReFill) * 60 * 1000)).getTime());
        // need to set selected charger to calculate estimate for the selected connector
        // setSelectedCharger(connector.connectorID);
        // console.log("locked amount in default check: ", lockedAmount)
        let loopIsNightCharging = isNightChargingForSlot(connector.availableDuration, connector.nightChargerPossible);
        let minimumBalanceAvailableForSelectedDuration = checkMinimumBalance(lockedAmount, connector.availableDuration, startInstantly, connector.connectorID, loopIsNightCharging)
        // console.log("minimum balance available for available duration: ", minimumBalanceAvailableForSelectedDuration)
        if (!minimumBalanceAvailableForSelectedDuration) {
          // console.log("minimum balance not available for selected duration: ", connector.availableDuration)
          for (let timeDuration = connector.availableDuration; timeDuration >= (locationData[0]?.minChargeDuration * 60) ?? 15; timeDuration -= 15) {
            // console.log("timeDuration loop in default check: ", timeDuration)
            endDateTime.setTime(new Date(startDateTime.getTime() + ((timeDuration + durationReFill) * 60 * 1000)).getTime());
            // console.log("loop timeDuration: ", timeDuration)
            let loopIsNightCharging = isNightChargingForSlot(timeDuration, connector.nightChargerPossible);
            let isMinimumBalanceCheckPassed = checkMinimumBalance(lockedAmount, timeDuration, startInstantly, connector.connectorID, loopIsNightCharging)
            // console.log("minimum balance check : ", isMinimumBalanceCheckPassed)
            let removeConnector = true
            if (isMinimumBalanceCheckPassed) {
              // console.log("minimum balance available for time duration: ", timeDuration)
              connector.availableDuration = timeDuration
              connector.energyDelivered = ((timeDuration / 60) * connector.power)
              connector.allocationScore = (((timeDuration / 60) * connector.power) * energyWeight) + ((timeDuration / 60) * durationWeight) + (connector.power * powerWeight)
              removeConnector = false
              break
            }
            if (removeConnector && timeDuration === 15) {
              // console.log("inside zero: ", connector.connectorID)
              idsToRemove.push(connector.connectorID);
              // const index = connectorAvailabilityArray.findIndex(
              //   item => item.connectorID === idToRemove
              // );

              // if (index !== -1) {
              //   connectorAvailabilityArray.splice(index, 1);
              // }
              defaultMinimumBalanceAvailable = false
              // connector.availableDuration = 0
              // connector.energyDelivered = (0 * connector.power)
              // connector.allocationScore = ((0 * connector.power) * energyWeight) + (0 * durationWeight) + (connector.power * powerWeight)
            }
          }
        }
      })
      idsToRemove.map((idToRemove) => {
        const index = connectorAvailabilityArray.findIndex(
          item => item.connectorID === idToRemove
        );

        if (index !== -1) {
          connectorAvailabilityArray.splice(index, 1);
        }
      })

      connectorAvailabilityArray.sort((a, b) => {
        
        if (userPreferredConnector?.l2) {
          const aIsPreferred = a.connectorType === userPreferredConnector.l2 ? 1 : 0;
          const bIsPreferred = b.connectorType === userPreferredConnector.l2 ? 1 : 0;
          if (bIsPreferred !== aIsPreferred) {
            return bIsPreferred - aIsPreferred; 
          }
        }

       
        if (b.allocationScore !== a.allocationScore) {
          return b.allocationScore - a.allocationScore;
        }

        return a.utScore - b.utScore;
      });


      let selectedTimeInChargerTZ = new Date(selectedTime.toLocaleString('en-US', { timeZone: locationTimezone }));
      // console.log("selectedTimeInChargerTZ: ", selectedTimeInChargerTZ)
      let offset = selectedTimeInChargerTZ.getTime() - selectedTime.getTime();
      let durationToNegate = durationReFill;
      let newStartTimeInChargerTZ = new Date(selectedTimeInChargerTZ.getTime() - (durationToNegate * 60 * 1000));

      let setDefaultDurationToThreeHours = false;


      if ((newStartTimeInChargerTZ.getHours() >= 21 && newStartTimeInChargerTZ.getHours() <= 23) || (newStartTimeInChargerTZ.getHours() >= 0 && newStartTimeInChargerTZ.getHours() <= 5 && (newStartTimeInChargerTZ.getHours() === 5 ? newStartTimeInChargerTZ.getMinutes() <= 45 : true))) {
        setDefaultDurationToThreeHours = true
      }

      // newStartTimeInChargerTZ >= 9 pm && newStartTimeInChargerTZ <= 5.45 am :
      // set duration to 3hr 

      let nightChargeEndTime;

      if (newStartTimeInChargerTZ.getHours() >= 9 && newStartTimeInChargerTZ.getHours() <= 23) {
        nightChargeEndTime = new Date(new Date(newStartTimeInChargerTZ.getTime() + 24 * 60 * 60 * 1000).setHours(9, 0, 0, 0));
      }
      else {
        nightChargeEndTime = new Date(new Date(newStartTimeInChargerTZ).setHours(9, 0, 0, 0));
      }
      // console.log("night chargerEndTime: ", nightChargeEndTime)
      // console.log("offset : ", offset)
      let nightChargeEndTimeInLocalTZ = new Date(nightChargeEndTime.getTime() - offset);
      let nightChargeStartTimeInLocalTZ = new Date(new Date(nightChargeEndTimeInLocalTZ).getTime() - (12 * 60 * 60 * 1000))
      let endDateTimeTemp = new Date(endDateTime)
      let nightChargeSlotUsedConnectors = checkSlotAvailable(true, true, (nightChargeEndTimeInLocalTZ.getTime() - selectedTime.getTime()) > 0 ? (nightChargeEndTimeInLocalTZ.getTime() - selectedTime.getTime()) / (1000 * 60) : 0)
      // console.log("nightChargeSlotUsedConnectors: ", nightChargeSlotUsedConnectors)
      // console.log("end date time after check solot for night charge default: ", endDateTime)
      endDateTime.setTime(endDateTimeTemp.getTime())
      connectorAvailabilityArray.map((connector, index) => {

        if (nightChargeSlotUsedConnectors.some(usedconnector => usedconnector._id.toString() === connector.connectorID)) {
          connectorAvailabilityArray[index].nightChargerPossible = false
        } else {
          connectorAvailabilityArray[index].nightChargerPossible = true
        }
      })
      // console.log("connectorAvailabilityArray after night charger check: ", JSON.parse(JSON.stringify(connectorAvailabilityArray)))





      // console.log("nightChargerEndTime in charger timezone: ", nightChargerEndTime)
      // console.log("offset value: ", offset)
      // console.log(
      //   "nightChargerEndTime in local timezone: ", new Date(nightChargerEndTime.getTime() - offset)
      // )


      // let limitStartTimeInChargerTZ = new Date(newStartTimeInChargerTZ);

      // limitStartTimeInChargerTZ.setHours(20,45,0,0);
      // let limitEndTimeInChargerTZ = new Date(new Date(limitStartTimeInChargerTZ).getTime() + ((15 + (11 * 60)) * 60 * 1000));




      // console.log("connectorAvailabilityArray updated: ", JSON.parse(JSON.stringify(connectorAvailabilityArray)))
      setConnectorAvailabilityArrayState(connectorAvailabilityArray)
      setavailableConnectorsInSelectedDurationState(connectorAvailabilityArray)

      let availableChargerList = [];

      chargers.forEach((charger) => {
        const hasMatchingConnector = charger.connector.some((connector) =>
          connectorAvailabilityArray.some(
            (connectorItem) =>
              connectorItem.connectorID === connector._id.toString()
          )
        );

        if (hasMatchingConnector && !availableChargerList.includes(charger)) {
          availableChargerList.push(charger);
        }
      });
      let availableConnectorList = connectors.filter(
        connector => connectorAvailabilityArray.some(availableConnector => availableConnector.connectorID === connector._id)
      );
      // console.log("available connectors list: ", availableConnectorList)

      setAvailableChargers(availableChargerList);
      setAvailableConnectors(availableConnectorList)

      if (connectorAvailabilityArray.length > 0) {

        let { nightChargingPossibleWithoutDuration, isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector } = checkNightCharging(connectorAvailabilityArray, nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, null);
        
        // night charging connector type and pref connector type same || different connector and pref conn not in availability array => night charging possible,
        //  not same but pref connector type in availability array => priority to pref connector type
        let nightChargePossiblityBasedOnPrefConnector = true
        if(userPreferredConnector.l2 && nightChargingConnector !== null){
          if((nightChargingConnector.connectorType === userPreferredConnector.l2) || 
          ((nightChargingConnector.connectorType !== userPreferredConnector.l2) && !(connectorAvailabilityArray.some(connector => connector.connectorType === userPreferredConnector.l2)))){
            nightChargePossiblityBasedOnPrefConnector = true
          }else if((nightChargingConnector.connectorType !== userPreferredConnector.l2) && (connectorAvailabilityArray.some(connector => connector.connectorType === userPreferredConnector.l2))){
            nightChargePossiblityBasedOnPrefConnector = false
          }
        }

        // console.log("check night charging response: ", nightChargingPossibleWithoutDuration,  isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector)
        if (nightChargingPossibleWithoutDuration === false) {
          setIsNightChargingPossible(false)
          setIsNightCharging(false)
        } else {
          (isNightChargingAvailable && nightChargingConnector != null && doesBookingEndExceedNightEndVar == false && nightChargePossiblityBasedOnPrefConnector == true) 
                                                                                        ? setIsNightCharging(true) : setIsNightCharging(false)
          nightChargePossiblityBasedOnPrefConnector == true ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
          // isNightChargingAvailable ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
          // possibility of night charging 
          // cause wallet -> night connector available & isNightChargingAvailable false & nightCahrgingPossible without duration true
        }
        // console.log("night charging connector available: ", nightChargingConnector);

        // console.log("startinstantly: ", startInstantly, "duration refill: ", durationReFill)
        (nightChargingPossibleWithoutDuration && isNightChargingAvailable && nightChargingConnector !== null && nightChargePossiblityBasedOnPrefConnector == true) ? setSelectedCharger((startInstantly || durationReFill>0) ? '' : nightChargingConnector.connectorID) :
          ((nightChargingPossibleWithoutDuration && nightChargingConnector !== null && setDefaultDurationToThreeHours && nightChargePossiblityBasedOnPrefConnector == true) ? setSelectedCharger((startInstantly || durationReFill>0) ? '' : nightChargingConnector.connectorID) : ((nightChargingConnector !== null && nightChargePossiblityBasedOnPrefConnector == true) ? setSelectedCharger((startInstantly || durationReFill>0) ? '' : nightChargingConnector.connectorID) : setSelectedCharger((startInstantly || durationReFill>0) ? '' : connectorAvailabilityArray[0].connectorID)))
        if ((isNightChargingAvailable == false || nightChargingConnector == null || doesBookingEndExceedNightEndVar == true)) { // not night charging 
          if (userPreferredConnector.l2) { // user perf connector available.
            if (connectorAvailabilityArray[0].connectorType !== userPreferredConnector.l2) { // pref connector not in availability array 
              setBookingAllocationAlgorithm("AL-02")
            } else { // pref connector in availability array 
              setBookingAllocationAlgorithm("AL-01")
            }
          } else { // user perf connector not available
            setBookingAllocationAlgorithm("AL-03")
          }
        } else { // night charging 
          if(userPreferredConnector.l2){ // user pref connector available
            if(userPreferredConnector.l2 == nightChargingConnector.connectorType){ // pref connector is night charging connector
              setBookingAllocationAlgorithm("AL-04")
            }else if ((userPreferredConnector.l2 != nightChargingConnector.connectorType) && (connectorAvailabilityArray.some(connector => connector.connectorType === userPreferredConnector.l2))){ 
              // pref connector not equal to night charge connector and its available in connector availability array 
              setBookingAllocationAlgorithm("AL-05")
            }else{
              // pref connector not equal to night charge connector and its not available in connector availability array 
              setBookingAllocationAlgorithm("AL-06")
            }
          }else{
            // pref connector not available
            if(nightChargingConnector){
              setBookingAllocationAlgorithm("AL-07")
            }else{
              setBookingAllocationAlgorithm("AL-08")
            }
          }
        }

        if (nightChargingPossibleWithoutDuration && !isNightChargingAvailable && nightChargingConnector !== null && doesBookingEndExceedNightEndVar == false && (newStartTimeInChargerTZ.getHours() <= 20 && newStartTimeInChargerTZ.getHours() >= 9) && nightChargePossiblityBasedOnPrefConnector == true) {
          // booking End Time (charger tz); <= 8.45 
          let newBookingEndForNightCharge = new Date(newStartTimeInChargerTZ);
          newBookingEndForNightCharge.setDate(newBookingEndForNightCharge.getDate() + 1);
          newBookingEndForNightCharge.setHours(0, 0, 0, 0);
          // console.log("inside set extra duration : ", (newBookingEndForNightCharge - newStartTimeInChargerTZ) / (1000 * 60))
          setShowExtraDurationForNightCharge((newBookingEndForNightCharge - newStartTimeInChargerTZ) / (1000 * 60))
        }

        // setSelectedCharger(connectorAvailabilityArray[0].connectorID);
        // locationData[0].chargerAllocationConfiguration === 'Random' ? setSelectedCharger(getRandomChargerId(connectorList)) : setSelectedCharger(getSortedChargerId(connectorList));
        setBookingSlotAvailability(true);

        // setDuration(connectorAvailabilityArray[0].availableDuration)

        (nightChargingPossibleWithoutDuration && isNightChargingAvailable && nightChargingConnector !== null && nightChargePossiblityBasedOnPrefConnector == true) ? setDuration(nightChargingConnector.availableDuration) :
          (nightChargingPossibleWithoutDuration && nightChargingConnector !== null && setDefaultDurationToThreeHours && nightChargePossiblityBasedOnPrefConnector == true) ? setDuration(180) : ((nightChargingConnector !== null && nightChargePossiblityBasedOnPrefConnector == true) ? setDuration(nightChargingConnector.availableDuration) : setDuration(connectorAvailabilityArray[0].availableDuration));

        // setDurationReFill(maxAllowedDuration)
        // console.log("duration refill: ", ((endDateTime - startDateTime) / (1000 * 60)) - maxAllowedDuration)
        // if (startInstantly) {
        //   setDurationReFill((((endDateTime - startDateTime) / (1000 * 60)) - maxAllowedDuration) > 0 ? (((endDateTime - startDateTime) / (1000 * 60)) - maxAllowedDuration) : 0)
        // }
        (nightChargingPossibleWithoutDuration && isNightChargingAvailable && nightChargingConnector !== null && nightChargePossiblityBasedOnPrefConnector == true) ? setDefaultBookingDuration(nightChargingConnector.availableDuration) :
          (nightChargingPossibleWithoutDuration && nightChargingConnector !== null && setDefaultDurationToThreeHours && nightChargePossiblityBasedOnPrefConnector == true) ? setDefaultBookingDuration(180) : ((nightChargingConnector !== null && nightChargePossiblityBasedOnPrefConnector == true) ? setDefaultBookingDuration(nightChargingConnector.availableDuration) : setDefaultBookingDuration(connectorAvailabilityArray[0].availableDuration));
        // setDefaultBookingDuration(connectorAvailabilityArray[0].availableDuration)
        // break
        if ((nightChargingPossibleWithoutDuration && nightChargingConnector !== null && setDefaultDurationToThreeHours)) {
          let tempConnectorAvailabilityArray = connectorAvailabilityArray
          tempConnectorAvailabilityArray = tempConnectorAvailabilityArray.map((connector) => {
            if (connector.nightChargerPossible && connector.availableDuration < 180) {
              connector.availableDuration = 180
            }
            return connector
          })
          setConnectorAvailabilityArrayState(tempConnectorAvailabilityArray)
          setavailableConnectorsInSelectedDurationState(tempConnectorAvailabilityArray)
        }
      } else {
        setSelectedCharger("");
        if (duration !== "") {
          setBookingSlotAvailability(false)
        }
      }

      if (!defaultMinimumBalanceAvailable && connectorAvailabilityArray.length === 0) {
        setMinimumBalanceAvailable(false)
      }

      // console.log("endDate time after default charger assgin : ", endDateTime)
      // console.log("duration value in default charger assign: ", duration)

    }


    if (lockedAmount !== null && !doesUserInput) {
      startInstantly ? durationReFill && assignDefaultCharger() : assignDefaultCharger();
    }

    // console.log("assign default charger useeffect called...")

    // duration && setMinimumBalanceAvailable(checkMinimumBalance(lockedAmount))

  }, [chargers, durationReFill, lockedAmount, balance]); //[chargers, currentTimeOne]


  const checkNightCharging = (connectorAvailabilityArray, nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, nightChargingConnectorData = null) => {
    let nightChargingPossibleWithoutDuration = false;
    // let isNightChargingConnectorAvailable = false;
    let nightChargingConnector = nightChargingConnectorData;
    let isNightChargingAvailable = false
    let doesBookingEndExceedNightEndVar = false
    if (!isNightChargingAllowedInLocation) {
      return { nightChargingPossibleWithoutDuration: false, isNightChargingAvailable: false, doesBookingEndExceedNightEndVar: false, nightChargingConnector: null }
    }

    if (nightChargingConnector == null) {
      connectorAvailabilityArray.some(connector => {
        if (connector.nightChargerPossible === true) {
          nightChargingConnector = connector;
          return true;
        }
        return false;
      });
    } else {
      nightChargingConnector = nightChargingConnectorData.nightChargerPossible === true ? nightChargingConnector : null
    }

    // console.log("nightChargingConnector: ", nightChargingConnector)
    // check  conditons without duration using either nightChargingConnector  / 0 th connector
    // nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, startDateTime
    // console.log("startDate time ; , ", startDateTime)
    // let bookingDurationForNightCharging = (nightChargingConnector !== null ? nightChargingConnector.availableDuration : connectorAvailabilityArray[0].availableDuration)
    let bookingStartDateTimeInLocalTZ = new Date(startDateTime)
    let bookingEndDateTimeInLocalTZ = new Date(new Date(startDateTime).getTime() + (durationReFill * 60 * 1000) + ((duration !== null && duration !== "" && duration !== 0 && duration !== '0') ? (duration * 60 * 1000) : (nightChargingConnector !== null ? (nightChargingConnector.availableDuration * 60 * 1000) : (connectorAvailabilityArray[0].availableDuration * 60 * 1000))))
    // console.log("bookingStartDate time in local TZ: ", bookingStartDateTimeInLocalTZ)
    // console.log("bookingEndDate time in local TZ: ", bookingEndDateTimeInLocalTZ)
    // console.log("duration refill; ", durationReFill)
    // console.log("duration in check night charge: ", duration);

    // console.log("booking start time in local timezone : ", bookingStartDateTimeInLocalTZ)
    // console.log("night conncector available duration: ", nightChargingConnector.availableDuration)
    // console.log("booking endDAte time in local tizme zone: ", bookingEndDateTimeInLocalTZ)
    // console.log("nightCharge start time in lcoal time zone: ", nightChargeStartTimeInLocalTZ)
    // console.log("night charge end in local timezone: ", nightChargeEndTimeInLocalTZ)

    if ((bookingEndDateTimeInLocalTZ.getTime() - nightChargeEndTimeInLocalTZ.getTime()) >= 0) {
      doesBookingEndExceedNightEndVar = true
    }
    //booking start < 9pm end > 9pm & < 8am  ->   9pm - booking end >= 3hr 
    if ((bookingStartDateTimeInLocalTZ <= nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ > nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ <= nightChargeEndTimeInLocalTZ)) {
      console.log("1st condition ")
      nightChargingPossibleWithoutDuration = true;
      if ((bookingEndDateTimeInLocalTZ - nightChargeStartTimeInLocalTZ) >= 180 * 60 * 1000) {
        isNightChargingAvailable = true
      }
    } //booking start < 8am & > 9pm  and booking end > 8am -> booking start - 8am >= 3hr
    else if ((bookingStartDateTimeInLocalTZ <= nightChargeEndTimeInLocalTZ) && (bookingStartDateTimeInLocalTZ > nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ > nightChargeEndTimeInLocalTZ)) {
      console.log("2nd condition")
      nightChargingPossibleWithoutDuration = true;
      if ((nightChargeEndTimeInLocalTZ - bookingStartDateTimeInLocalTZ) >= 180 * 60 * 1000) {
        isNightChargingAvailable = true
      }
    }// booking start < 9pm  and booking end > 8am -> night charging 
    else if ((bookingStartDateTimeInLocalTZ <= nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ >= nightChargeEndTimeInLocalTZ)) {
      console.log("3rd condition")
      nightChargingPossibleWithoutDuration = true;
      if ((nightChargeEndTimeInLocalTZ - nightChargeStartTimeInLocalTZ) >= 180 * 60 * 1000) {
        isNightChargingAvailable = true
      }
    }//booking start > 9pm & < 8 am  booking end >9pm & < 8am
    else if ((bookingStartDateTimeInLocalTZ >= nightChargeStartTimeInLocalTZ) && (bookingStartDateTimeInLocalTZ < nightChargeEndTimeInLocalTZ)
      && (bookingEndDateTimeInLocalTZ > nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ <= nightChargeEndTimeInLocalTZ)) {
      console.log("4th condition")
      nightChargingPossibleWithoutDuration = true;
      if ((bookingEndDateTimeInLocalTZ - bookingStartDateTimeInLocalTZ) >= 180 * 60 * 1000) {
        isNightChargingAvailable = true
      }
    }
    setDoesBookingEndExceedNightEnd(doesBookingEndExceedNightEndVar)
    // if(nightChargingPossibleWithoutDuration === false){
    //   setIsNightChargingPossible(false)
    //   setIsNightCharging(false)
    // }else{
    //   isNightChargingAvailable ? setIsNightCharging(true) : setIsNightCharging(false)
    //   setIsNightChargingPossible(true)
    //   // isNightChargingAvailable ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
    //   // possibility of night charging 
    //   // cause wallet -> night connector available & isNightChargingAvailable false & nightCahrgingPossible without duration true
    // }

    return { nightChargingPossibleWithoutDuration, isNightChargingAvailable, doesBookingEndExceedNightEndVar, nightChargingConnector }
  }



  // useEffect(()=>{
  //   if(isBookingNonRes){
  //     if(!isAutoPayEnabled){
  //       // let lockedAmount = getLockedAmount()
  //       console.log("locked amount for non-res estimate: ", lockedAmount)
  //       let minimumBalanceAvailable;
  //       console.log("locationData[0].maxChargeDuration: ", locationData[0].maxChargeDuration)
  //       for (let i=locationData[0].maxChargeDuration;  i>0 ; i--){
  //         console.log("i in for loop :", i)
  //         setDuration(i*60)
  //         console.log("duration in estimate calculation: ", i*60)
  //         minimumBalanceAvailable = checkMinimumBalance(lockedAmount, i*60)
  //         console.log("minimum balance available for ", i , minimumBalanceAvailable)
  //         if(minimumBalanceAvailable){
  //           setNonResBookingDuration(i*60)
  //           setNonResBookingAllowed(true)
  //           break
  //         }
  //       }
  //       if(!minimumBalanceAvailable){
  //         setNonResBookingAllowed(false)
  //         console.log("enable auto pay or recharge wallet")
  //       }
  //     }
  //   }
  // },[lockedAmount, selectedTime, isCustomEnergyRateForSelectedLocation, isFreeChargingForSelectedLocation])



  const handleAnimationRender = () => {
    if (duration !== "" > 0 && bookingSlotAvailability && minimumBalanceAvailable) {
      const timer = setTimeout(() => {
        setRenderTickMark(true);
      }, 200);

      // Clean up the timer
      return () => clearTimeout(timer);
    } else {
      setRenderTickMark(false);
    }
  }

  useEffect(() => {
    handleAnimationRender()
  }, [duration, startTime, bookingSlotAvailability, minimumBalanceAvailable])



  const checkMinimumBalance = (lockedAmount = 0, time = duration, startInstantly = false, connectorId = null, overrideIsNightCharging = null) => {
    // console.log("calling checkminimum balance ...............................")
    let currentIsNightCharging = overrideIsNightCharging !== null ? overrideIsNightCharging : isNightCharging;
    // console.log("duration in checkminimum balance: ", time)
    // let onGoingBookingEstimate = calculateEstimatedAmount(time)
    // console.log("isAutopay enabled: ", isAutoPayEnabled)
    // if (isAutoPayEnabled) {
    //   return true
    // }

    // if(endDateTime === null){
    //   setEndDateTime(new Date(new Date(startDateTime).getTime()+(time*60*1000)))
    // }
    // console.log("startDateTime in checkMinimumBalance: ", startDateTime)
    // console.log("connector id in check minimum balnce: ", connectorId)
    // console.log("selectedCharger in check minimum balance: ", selectedCharger)
    // console.log("Params to calculate estimate amount : \n", time, startDateTime, endDateTime, connectorId === null ? selectedCharger : connectorId, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, startInstantly)
    let onGoingBookingEstimate = Helper.calculateEstimatedAmount(time, startDateTime, endDateTime, connectorId === null ? selectedCharger : connectorId, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, startInstantly, userAvgPower, currentIsNightCharging, locationData[0]?.gracePeriodInMinutes ?? 10);
    // console.log("onGoingBookingEstimate", onGoingBookingEstimate)
    // console.log("rate split from estimate: ", onGoingBookingEstimate.rateSplit)
    setEstimateSplit(onGoingBookingEstimate.rateSplit)

    let nightChargeAmount = isFreeChargingForSelectedLocation ? 0 : ((currentIsNightCharging && availableNightCharging <= 0) ? 2 : 0)
    // console.log("nightChargeAmount: ", nightChargeAmount)
    // console.log("isFreeChargingForSelectedLocation: ", isFreeChargingForSelectedLocation)
    // console.log("isNightCharging: ", isNightCharging)
    // console.log("availableNightCharging: ", availableNightCharging)
    setNightChargingEstimate(nightChargeAmount)
    // console.log("onGoingBookingEstimate in check minimum balance: ", onGoingBookingEstimate.estimateAmount)
    // console.log("night charge amount in check minimum balance: ", nightChargeAmount)
    isFreeChargingForSelectedLocation ? setEstimateAmount(0) : setEstimateAmount(onGoingBookingEstimate.estimateAmount + nightChargeAmount)
    // setEstimateAmount(onGoingBookingEstimate.estimateAmount)

    // Guests pay via a per-booking Stripe hold after booking, not the shared
    // pool account's wallet, so its balance/autopay state doesn't apply to them.
    if (isGuest) {
      return true
    }

    if (isAutoPayEnabled) {
      return true
    }

    if (isFreeChargingForSelectedLocation) {
      return true
    }
    // console.log("duration in checkMinimumBalance: ", time)
    let minimumBalance = parseFloat(lockedAmount) + parseFloat(onGoingBookingEstimate.estimateAmount + nightChargeAmount)
    // console.log("locked amount in check minimum balance: ", lockedAmount)
    // console.log("total minimum balance required in check Minimum balance: ", minimumBalance, balance)
    // console.log(onGoingBookingEstimate)
    // console.log("minimum balance check in checkMinimum Balance: ", minimumBalance , typeof(minimumBalance))
    // console.log("balance in users wallet ; ", balance, typeof(balance))
    if (parseFloat(balance) < parseFloat(minimumBalance)) {
      
      if (minimumBalance - balance > 10) {
        // console.log("balance is less than minimum balance required: ", balance, minimumBalance)
        setAmountToAdd(Math.ceil(minimumBalance - balance))
        // console.log("amount to add: ", Math.ceil(minimumBalance - balance))
      }else{
        setAmountToAdd(10)
      }
      // console.log("inside -ve condition for check Minimum balance:")
      return false;
    }
    setAmountToAdd(10)
    return true
  }



  const submitBooking = async (bookingData, bookingCreatedAt, guestPaymentIntentId = null) => {
    try {
      setIsSubmitting(true);
      const res = await BreathAPIs.makeBooking(bookingData, bookingCreatedAt, guestPaymentIntentId);
      // console.log("after calling make booking ", res)
      setTrigger(!trigger);
      handleNewBooking(bookingData);
      handleMakeToast("success", res.data?.msg || res.data);
    } catch (err) {
      console.error("Error in makeBooking api call:", err);
      refetchBookings();
      if (err.response) {
        console.error("Response data:", err.response.data);
        // Check for 400 status code and handle it specifically
        if (err.response.status === 400) {
          handleMakeToast("error", "Bad request: " + (err.response.data.errors.msg || "An error occurred"));
        } else if (err.response.status === 402) {
          handleMakeToast("error", err.response.data.errors.msg || "An error occurred");
        }
        else {
          handleMakeToast("error", err.response.data.errors.msg || "An error occurred");
        }
      } else if (err.request) {
        console.error("No response received:", err.request);
        handleMakeToast("error", "No response received from the server");
      } else {
        console.error("Error setting up the request:", err.message);
        handleMakeToast("error", "An error occurred while processing your request");
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleSubmit = async (e) => {
    // console.log("handle submit called")
    e.preventDefault();
    let selectedChargerData = selectedCharger ? chargers.filter((charger) => { return String(charger._id) === String(selectedCharger) })[0] : chargers[0] // need to change when converting into connector level reservation

    let bookable = true;
    // availableConnectors.map((connector) => {
    //                     const chargerData = availableChargers.find((charger) =>
    //                       charger.connector.some((c) => c._id === connector._id)
    //                     ))
    let choosenCharger = chargers.filter((charger) => {
      return charger.connector.some((c) => c._id === selectedCharger)
    })    // console.log("selectedChargerForNonRes in make Booking: : ", selectedChargerForNonRes)
    // console.log("choosenCharger in make booking: ", choosenCharger)
    // console.log("startDate time inside booking data: ", startDateTime)
    const bookingData = {
      nonReservable: isBookingNonRes ? true : false,
      charger: choosenCharger[0]._id,
      isNightCharging: isNightCharging,
      nightChargeEstimate: nightChargingEstimate,
      connector: selectedCharger, // need to change when converting into connector level reservation
      startTime: startDateTime,
      endTime: endDateTime,
      endTimeOverNight: isNightCharging ? endDateTime : null,
      endTimeScheduled: endDateTime,
      date: startDateTime.toISOString().split("T")[0], // get the date part in yyyy-mm-dd format
      user: userID,
      bookingType: isFreeChargingForSelectedLocation ? 'free' : (estimateAmount === 0 ? 'freeDynamic' : "paid"),
      time: new Date(),
      unUtilizedTime: {
        total: (new Date(endDateTime) - new Date(startDateTime)) / 1000,
        freeTime: 0,
        paidTime: (new Date(endDateTime) - new Date(startDateTime)) / 1000
      },
      estimateAmount: estimateAmount,
      dynamicRates: rateType === "dynamic" ? dynamicRanges : [],
      normalRate: normalRate,
      rateType: isCustomEnergyRateForSelectedLocation ? 'fixed' : rateType,
      allocationAlgorithm: doesUserInput ? "user-input" : bookingAllocationAlgorithm,
      bookingCreationSource: "webApp",
      bookingModifications: (durationReFill > 0) ? [
        {
          type: "initiate-now",
          time: new Date(),
          currentTime: {
            start: startDateTime,
            end: endDateTime
          },
          newTime: {
            start: startDateTime,
            end: endDateTime
          }
        }
      ] : []
    };
    // console.log("bookingData in booking form : ", bookingData)

    if (checkSlotAvailable(false) === false) {

      return;
    }


    bookable = checkMinimumBalance(lockedAmount)

    const bookingCreatedAt = new Date()

    // Guests must authorize a card hold before the booking is created - the
    // modal calls submitBooking itself once the hold succeeds.
    if (isGuest && estimateAmount > 0) {
      setGuestPaymentBooking({ bookingData, bookingCreatedAt });
      return;
    }

    await submitBooking(bookingData, bookingCreatedAt);
  }

  function chargeDuration() {
    if (duration === "") {
      return '(booking time - 10 minutes)';
    }

    let totalMinutes = parseFloat(duration, 10);
    totalMinutes -= isNightCharging ? 0 : totalMinutes >= 30 ? locationData[0]?.gracePeriodInMinutes ?? 10 : 5;
    totalMinutes += durationReFill;
    let outputHours = Math.floor(totalMinutes / 60);
    let outputMinutes = totalMinutes % 60;
    let formattedOutput = "";
    if (outputHours > 0) {
      formattedOutput += outputHours + " hour";
      if (outputHours > 1) {
        formattedOutput += "s";
      }
      formattedOutput += ", ";
    }
    formattedOutput += outputMinutes + " minute";
    if (outputMinutes !== 1) {
      formattedOutput += "s";
    }
    return formattedOutput;
  }

  function formatRateRangeTime(rangeStart, rangeEnd) {
    const opts = { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm };
    const startLabel = new Date(rangeStart).toLocaleTimeString('en-US', opts);
    const endLabel = new Date(rangeEnd).toLocaleTimeString('en-US', opts);
    return `${startLabel} - ${endLabel}`;
  }

  const selectedChargerDataForRegularRate = isBookingNonRes ? selectedChargerForNonRes : (selectedCharger ? chargers.find((charger) => Array.isArray(charger.connector) && charger.connector.find((conn) => String(conn._id) === String(selectedCharger))) : chargers[0]);
  const regularRatePerKwh = isCustomEnergyRateForSelectedLocation ? parseFloat(customEnergyRate) : (selectedChargerDataForRegularRate ? selectedChargerDataForRegularRate.rate.price_components.price : 0);

  const today = new Date().toISOString().split('T')[0];

  const totalDuration = (parseInt(duration) + parseInt(durationReFill));


  useEffect(() => {
    if (startInstantly) {
      setDurationReFill(formatTime(new Date(), new Date(selectedTime), timeFormatAmPm)?.diffMins + 1);
    }
    // else {
    //   setDurationReFill(0);
    // }
  }, [startInstantly, duration, currentTimeOne]);

  useEffect(()=>{
    if(selectedCharger){
      // console.log("selectedCharger: ", selectedCharger)
      // console.log("available connectors: ", availableConnectors)
      let selectedConnectorType = availableConnectors.find((connector) => String(connector._id) === String(selectedCharger))
      // console.log("selectedConnectorType: ", selectedConnectorType.type)
      if(userPreferredConnector.l2){
        userPreferredConnector.l2 !== selectedConnectorType.type ? setShowDifferentTypeConnectorSelected(true) : setShowDifferentTypeConnectorSelected(false)
      }
    }
  }, [selectedCharger])



  // const nightChargeCheckCall = (checked) => {
  //   if (checked) {
  //     if(duration < 180){
  //       console.log("duration less than 3 hours, set to min 3 hours")
  //       setDuration(180);
  //       setDefaultBookingDuration(180);
  //     }
  //     setIsNightCharging(true)
  //     console.log("Night charge enabled");
  //   } else {
  //     setIsNightCharging(false)
  //     console.log("Night charge disabled");
  //   }
  // }



  // useEffect(() => {
  //   if(duration && duration !== ""){

  //   let selectedTimeInChargerTZ = new Date(selectedTime.toLocaleString('en-US', { timeZone: locationTimezone }));
  //   let durationToNegate = durationReFill;
  //   let newStartTimeInChargerTZ = new Date(selectedTimeInChargerTZ.getTime() - (durationToNegate * 60 * 1000));
  //   let limitStartTimeInChargerTZ = new Date(newStartTimeInChargerTZ);

  //   limitStartTimeInChargerTZ.setHours(20,45,0,0);
  //   let limitEndTimeInChargerTZ = new Date(new Date(limitStartTimeInChargerTZ).getTime() + ((15 + (11 * 60)) * 60 * 1000));

  //   if(newStartTimeInChargerTZ > limitStartTimeInChargerTZ && newStartTimeInChargerTZ < limitEndTimeInChargerTZ && duration >= 180){
  //     // setShowNightChargeOption(true);
  //     console.log("within night charge window")
  //      setIsNightCharging(true)
  //      console.log("estiamate amount before night charge addition: ", estimateAmount)
  //     //  setEstimateAmount(estimateAmount + 5000)
  //     // if(duration < 180){
  //     //   console.log("duration less than 3 hours, set to min 3 hours")
  //     //   setDuration(180);
  //     //   setDefaultBookingDuration(180);
  //     // }
  //   }else{
  //     console.log("outside night charge window")
  //     // setShowNightChargeOption(false);   
  //     setIsNightCharging(false) 

  //   }
  // }
  //   // console.log("selected start Date time in charger timezone: ", new Date(selectedTime.toLocaleString('en-US', { timeZone: locationTimezone })));
  //   // console.log("duration Refill in useeffect: ", durationReFill)
  // }, [durationReFill, duration]);




  const handleInitiateNow = () => {
    setStartInstantly(!startInstantly);
    if (startInstantly)
      setDurationReFill(0)
  }

  let buttonElement;
  // console.log("isPhoneVerifiedState",isPhoneVerifiedState,"phoneState",phoneState)
  if (!isGuest && (!isPhoneVerifiedState || phoneState?.length === 0)) {
    buttonElement = (
      <button
        className={styles['button']}
        onClick={() => {
          setShowPhoneVerificationModal(true);
          // setDoesUserInput(false);
        }}
        type="button"
      >
        Verify Phone number
      </button>
    );
  } else if (minimumBalanceAvailable) {
    buttonElement = (
      <ButtonCustom
        disabled={
          isSubmitting ||
          duration === 0 ||
          !(instantTime?.diffMins >= 0) ||
          !bookingSlotAvailability ||
          (!minimumBalanceAvailable && isFreeChargingForSelectedLocation === false) ||
          bookingSlotConflictShared
        }
        isLoading={isSubmitting}
        text={
          isSubmitting
            ? (isBookingNonRes ? "Initiating..." : "Booking...")
            : (isBookingNonRes ? "Initiate" : "Book")
        }
        type="submit"
      />
    );
  } else {
    // console.log("add amount button disable condition: ", bookingSlotConflictShared)
    buttonElement = (
      <button
        className={styles['button']}
        disabled={
          bookingSlotConflictShared
        }
        onClick={() => {
          setWalletRechargeModal(true);
          setDoesUserInput(false);
          setIsNightCharging(false)
          setIsNightChargingPossible(false)
          setNightChargingEstimate(0)
          setDoesBookingEndExceedNightEnd(false)
        }}
        type="button"
      >
        Add Amount
      </button>
    );
  }


  const handleVerificationSuccess = async () => {
    try {
      const res = await BreathAPIs.updatePhone(phoneState)
      if (res.status === 200) {
        toast.success("Phone number updated successfully")
        store.dispatch(loadUser())
        setIsPhoneVerifiedstate(true)
      }
      if (res.status === 409) {
        toast.warning("Phone numeber exists")
      }

    } catch (error) {
      // console.log("Phone not updated",error)
      if (error.response.status === 409) {
        toast.warning("Phone numeber exists")
        return
      }
      toast.error("Could not verify phone number")
    }
  }

  return (
    <div className="container mt-4" style={{ marginBottom: "20px" }}>
      {/* {console.log("rendering booking form...", balance, isNightCharging)} */}

      <h2 className="text-center mb-4">{isBookingNonRes ? "Initiate Charging" : "Book your slot"}</h2>
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-10" >
          <form onSubmit={handleSubmit}>

            <div className="mb-3">
              <label className="form-label">Slot</label>
              <div className={`form-control d-flex justify-content-between align-items-center ${styles['time-slot']}`}>
                <span className={styles['slot-date']}>{formatDate(`${startDate} ${startTime}`)}</span>
                <span className={styles['slot-date-sm']}>{formatDate(`${startDate} ${startTime}`, 'short')}</span>
                <span className={`btn btn-primary btn-sm pe-none ${styles['btn-start-end-time']}`}>{startTimeDisplay} {endTimeDisplay}</span>
              </div>

              {(showChargerTime && !isBookingNonRes) &&

                <div className={styles['top-charger-timezone']}>
                  <div>
                    {locationTimezone}<FaChargingStation />
                    <div className={styles['charger-time']}>
                      <span>{formatDate(startDateDisplayChargerTime)} </span>
                      <span>{startTimeDisplayChargerTime} {endTimeDisplayChargerTime}</span>
                    </div>
                  </div>

                </div>
              }





              {/* {isUserTester &&
                <input type='number' min={0} value={durationReFill} className="form-control" onChange={(e) => { setDurationReFill(e.target.value) }} />

              } */}
            </div>



            {(extraTimeList.length && !isBookingNonRes) ? <div className={styles['duration-re-fill']}>

              <div className={styles['re-fill-message']}>Would you like to start earlier?</div>

              <button type='button' onClick={handleInitiateNow} className={`${styles['btn-instant-start']} ${startInstantly ? styles['active'] : undefined}`}>Now</button>

              {extraTimeList.length > 1 ? <div className={styles['button-grp']}>
                {extraTimeList.map((time, index) => (
                  <button className={time.diffMins === durationReFill ? styles['active'] : undefined} type='button' key={index + '-' + time.time} onClick={() => { setDurationReFill(time.diffMins); setStartInstantly(false) }}>{time.time}</button>
                ))}
              </div> : null}

              {duration ? <div className={styles['total-duration']}>Total Duration: <b>{parseInt(totalDuration / 60)}h : {totalDuration % 60}m</b></div> : null}
            </div> : <></>}


            {(isBookingNonRes && !nonResBookingAllowed) ? <></> : <label className="form-label">Select Duration</label>}
            <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>

              {isBookingNonRes ? (
                nonResBookingAllowed ?
                  <input
                    type="text"
                    value={`${duration / 60} hour(s)`}
                    disabled
                    className={`${styles.glassmorphic}`}
                  /> : <></>) : <>
                {/* <select
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                className={isBookingNonRes ? `${styles.glassmorphic}` : `form-select ${styles.glassmorphic}`}
                required
                disabled={isBookingNonRes}
              >
                <option value="" disabled>
                  0 hour
                </option>
                {userGroups.some(userGroup => userGroup.groupName === "Test-Users") ? [1 / 4, 1, 2, 3, 4, 5, 6].map((hour) => (


                  <option value={hour * 60} key={hour}>
                    {hour === 1 / 20 ? "3 minutes" : `${hour} hour(s)`}
                  </option>
                )) :

                  Array.from({ length: locationData[0]?.maxChargeDuration }, (v, i) => i + 1).map((hour) => (


                    <option value={hour * 60} key={hour}>
                      {hour === 1 / 20 ? "3 minutes" : `${hour} hour(s)`}
                    </option>
                  ))

                }
              </select> 
              */}
              {/* {console.log("duration value: ", duration, typeof(duration),minimumBalanceAvailable)} */}
                {/* {
                  minimumBalanceAvailable ? 
                  <HourMinuteSelector onChange={(val) => { setDuration(val); setDoesUserInput(true) }} defaultMinute={defaultBookingDuration} maxSelectionInMin={locationData[0]?.maxChargeDuration * 60} source='bookingForm' duration={duration} minimumBalanceAvailable={minimumBalanceAvailable}></HourMinuteSelector>
                  : 
                  (duration!==0 && duration!=='') ?
                  <HourMinuteSelector onChange={(val) => { setDuration(val); setDoesUserInput(true) }} defaultMinute={defaultBookingDuration} maxSelectionInMin={locationData[0]?.maxChargeDuration * 60} source='bookingForm' duration={duration} minimumBalanceAvailable={minimumBalanceAvailable}></HourMinuteSelector>
                  :
                  <></> 
                } */}
                <HourMinuteSelector onChange={(val) => { setDuration(val); setDoesUserInput(true) }} defaultMinute={defaultBookingDuration} maxSelectionInMin={locationData[0]?.maxChargeDuration * 60} source='bookingForm' duration={duration} minimumBalanceAvailable={minimumBalanceAvailable} minSelectionInMinutes={(locationData[0]?.minChargeDuration * 60) ?? 15}></HourMinuteSelector>
              </>
              }

            </div>
            {
              isBookingNonRes && <div>
                <label className='form-label'>Selected Charger</label>

                <input
                  type="text"
                  value={selectedChargerForNonRes.title}
                  disabled
                  className={`${styles.glassmorphic}`}
                />

              </div>
            }
            {Boolean(duration) && (userGroups.some(userGroup => userGroup.groupName === "Test-Users") ||
              (chargerSelection && (durationReFill > 0 || startInstantly))
            ) && <div className="mb-3">
                <div className={`${styles['connector-info']}`}><label className="form-label">Select Charger</label> </div>
                {/* <FaInfoCircle onClick={() => { setMoreInfo(!moreInfo) }} /> */}
                {

                  moreInfo && false &&
                  <div className={`${styles['info-data']}`}>
                    <div>(Charger Name) - # (Connector Number)</div>
                    {/* <div></div> */}
                  </div>
                }

                {availableConnectors?.length > 0 ?
                  <><select
                    value={selectedCharger}
                    onChange={(e) => { setSelectedCharger(e.target.value); setDoesUserInput(true) }}
                    className={`form-select ${styles.glassmorphic}`}
                    required
                  >
                    <option value="" disabled>
                      Select Charger
                    </option>
                    {
                      Boolean(duration) && availableConnectors.map((connector) => {
                        const chargerData = availableChargers.find((charger) =>
                          charger.connector.some((c) => c._id === connector._id)
                        );
                        return (
                          <option value={connector._id} key={connector._id}>
                            {`${chargerData.chargerTag} ${connector.noOfConnectorsInCharger != 1 ? `- #${connector.connectorNumber}` : ""}  (${connector.type})`} 
                          </option>)

                      })}
                  </select>  </>
                  :
                  <div className={styles['noChargersAvailable']}>No chargers available.</div>
                }



              </div>}


                {Boolean(duration) && (userGroups.some(userGroup => userGroup.groupName === "Test-Users") ||
              (chargerSelection && (durationReFill == 0 || startInstantly == false))
            ) && <div className="mb-3">
                {/* <div className={`${styles['connector-info']}`}><label className="form-label">Assigned Charger: {availableChargers.find((charger) => charger.connector.some((c) => c._id === selectedCharger))?.chargerTag} 
                      {availableConnectors.find((connector) => connector._id === selectedCharger)?.connectorNumber != 1 ? `- #${availableConnectors.find((connector) => connector._id === selectedCharger)?.connectorNumber}` : ""   + ` (${availableConnectors.find((connector) => connector._id === selectedCharger)?.type})`}</label> </div>
                 */}
                {/* <FaInfoCircle onClick={() => { setMoreInfo(!moreInfo) }} /> */}
                {

                  !(startInstantly || durationReFill>0 ) &&
                  <div className={`${styles['assigned-charger-data']}`}>  
                    <div>
                      Assigned Charger: <span>{availableChargers.find((charger) => charger.connector.some((c) => c._id === selectedCharger))?.chargerTag} 
                      {availableConnectors.find((connector) => connector._id === selectedCharger)?.connectorNumber != 1 ? `- #${availableConnectors.find((connector) => connector._id === selectedCharger)?.connectorNumber}` : ""   + ` (${availableConnectors.find((connector) => connector._id === selectedCharger)?.type})`}
                     </span> </div>
                    {/* <div></div> */}
                  </div>
                }

                {/* {availableConnectors?.length > 0 ?
                  <><select
                    value={selectedCharger}
                    onChange={(e) => { setSelectedCharger(e.target.value); setDoesUserInput(true) }}
                    className={`form-select ${styles.glassmorphic}`}
                    required
                  >
                    <option value="" disabled>
                      Select Charger
                    </option>
                    {
                      Boolean(duration) && availableConnectors.map((connector) => {
                        const chargerData = availableChargers.find((charger) =>
                          charger.connector.some((c) => c._id === connector._id)
                        );
                        return (
                          <option value={connector._id} key={connector._id}>
                            {`${chargerData.chargerTag} ${connector.noOfConnectorsInCharger != 1 ? `- #${connector.connectorNumber}` : ""}  (${connector.type})`} 
                          </option>)

                      })}
                  </select>  </>
                  :
                  <div className={styles['noChargersAvailable']}>No chargers available.</div>
                } */}




              </div>}


            {
              isNightChargingPossible &&
              <div className={styles['night-charge-info']}>
                <p> {isNightCharging ? <>
                  <FaMoon color='#e09839ff'> </FaMoon>
                  <Tooltip title="No idle fee until 9AM" color="#10396eff"
                    trigger="click" // Changes trigger from hover to click
                    open={isTooltipOpen} // Controls visibility
                    onOpenChange={(visible) => setIsTooltipOpen(visible)}>
                    <span style={{ color: "#10396eff" }} onClick={(e) => {
                      e.preventDefault();
                      setIsTooltipOpen(!isTooltipOpen);
                    }}> Overnight Booking </span>
                  </Tooltip>

                  {/* <TooltipView text={"overnigh booking info deatils"}/>  */}
                  (Monthly credits: {availableNightCharging}/4)</>
                  : ((showExtraDurationForNightCharge > 0 && (showExtraDurationForNightCharge / 60) < locationData[0]?.maxChargeDuration) ? <>Min. {parseInt(showExtraDurationForNightCharge / 60)}h {showExtraDurationForNightCharge % 60 != 0 ? showExtraDurationForNightCharge % 60 + "m" : ""} for

                    <Tooltip title="No idle fee until 9AM" color="#10396eff"
                      trigger="click" // Changes trigger from hover to click
                      open={isTooltipOpen} // Controls visibility
                      onOpenChange={(visible) => setIsTooltipOpen(visible)}>
                      <span style={{ color: "#10396eff" }} onClick={(e) => {
                        e.preventDefault();
                        setIsTooltipOpen(!isTooltipOpen);
                      }}> overnight booking</span>
                    </Tooltip>


                  </> : "")} </p>
              </div>
            }

            <div className="d-grid">
              {
                showDifferentTypeConnectorSelected &&
                <div className={styles['different-type-connector-selected']}>
                  {(startInstantly || durationReFill>0 ) ? 
                  <p>Selected connector isn't your preferred type {userPreferredConnector.l2 ? '(' + userPreferredConnector.l2 + ')' : ""}.</p>:
                  <p>Your preferred connector {userPreferredConnector.l2 ? '(' + userPreferredConnector.l2 + ')' : ""} isn’t available. You can update connector preference if you have an adapter.</p>
                }
                  {/* <p>Assigned connector isn't your preferred type {userPreferredConnector.l2 ? '(' + userPreferredConnector.l2 + ')' : ""}.</p> */}
                </div>
              }
              {/* {console.log("estimate amount in display: ", estimateAmount)}  */}
              {<>
                <div className={isNightCharging && nightChargingEstimate > 0 ? styles['estimated-amount-in-NightCharge'] : styles['estimated-amount']}>Estimated amount : $ {duration ? estimateAmount?.toFixed(2) : "0.00"}

                  {duration &&
                    <FaInfoCircle onClick={() => { setMoreInfo(!moreInfo) }} />
                  }
                </div>
                {/* {console.log("isNightCharging: ", isNightCharging)}
                {console.log("nightChargingEstimate: ", nightChargingEstimate)} */}
                {isNightCharging && nightChargingEstimate > 0 && <div className={styles['night-charge-estimated-amount']}> Overnight fee of $2 included.</div>}
              </>
              }

              {
                Boolean(duration) &&
                // moreInfo &&
                <div className={`${styles['info-data']}`}>
                  <div>Charge Duration: {chargeDuration()}</div>
                  <div>Grace Period: {isNightCharging ? `Until 9:00 AM ${showChargerTime ? '(' + locationTimezone + ')' : ""} ` : `${(duration + durationReFill) >= 30 ? locationData[0]?.gracePeriodInMinutes ?? 10 : 5} minutes, without energy delivery`}</div>
                  {isNightCharging && <div>
                    Prefer not to {availableNightCharging > 0 ?'use overnight credit' : 'pay $2 overnight fee'}? Move vehicle by {getEndTimeForNightCharge(null)}
                    {/* Move vehicle by {getEndTimeForNightCharge(null)} to avoid overnight {availableNightCharging > 0 ? 'credit use.' : 'fee.'} */}
                    </div>}
                  {
                    moreInfo &&
                    <>
                      <hr></hr>
                      <div className={styles.idleFeeDiv}>Idle Fee: <span className={styles.idleFeeSpan}>$ {idleFee}/min</span></div>
                      <div ><i className={styles.unutFeeDiv}>Charge for
                        <span className={styles.unutFeeSpan}>
                          <b>{parseInt((((duration + durationReFill) - ((duration + durationReFill) >= 30 ? 10 : 5)) * 0.7) / 60)}h
                            : {parseInt((((duration + durationReFill) - ((duration + durationReFill) >= 30 ? 10 : 5)) * 0.7) % 60)}m</b></span>
                        to avoid unutilized time fee </i></div>
                      {
                        ((estimateSplit?.dynamicRates?.length > 0 || estimateSplit?.normalRate > 0 || estimateSplit?.tax > 0) && estimateAmount > 0) &&
                        <>
                          <div className={styles.rateSplitTitle}>Rate Breakdown</div>
                          {estimateSplit.powerUsed > 0 &&
                            <div className={styles.idleFeeDiv}>
                              <span className={styles.rateSplitLabel}>Calculated using {estimateSplit.isUserAvgPowerUsed ? 'your average charging power' : "charger's rated power"}</span>
                              <span className={styles.rateSplitValue}>{estimateSplit.powerUsed?.toFixed(2)} kW</span>
                            </div>
                          }
                          {estimateSplit.dynamicRates.filter((range) => range.estimateInRange > 0).map((range, idx) => (
                            <div key={idx} className={styles.idleFeeDiv}>
                              <span className={styles.rateSplitLabel}>{formatRateRangeTime(range.rangeStart, range.rangeEnd)} @ $ {range.perkWhCost?.toFixed(2)}/kWh</span>
                              <span className={styles.rateSplitValue}>$ {range.estimateInRange?.toFixed(2)}</span>
                            </div>
                          ))}
                          {estimateSplit.normalRate > 0 &&
                            <div className={styles.idleFeeDiv}>
                              <span className={styles.rateSplitLabel}>Regular Rate ($ {regularRatePerKwh?.toFixed(2)}/kWh)</span>
                              <span className={styles.rateSplitValue}>$ {estimateSplit.normalRate.toFixed(2)}</span>
                            </div>
                          }
                          <div className={styles.idleFeeDiv}>
                            <span className={styles.rateSplitLabel}>Tax</span>
                            <span className={styles.rateSplitValue}>$ {(estimateSplit.tax || 0).toFixed(2)}</span>
                          </div>
                        </>
                      }
                    </>
                  }
                </div>
              }

              {
                // console.log("conditions: ", )
                ((!bookingSlotAvailability || (!minimumBalanceAvailable && isFreeChargingForSelectedLocation === false) || bookingSlotConflictShared) && !isBookingNonRes) &&
                <div className={styles["unavailable-container"]}>
                  {
                    (!minimumBalanceAvailable && !bookingSlotConflictShared) &&
                    <div>
                      <CgUnavailable className={styles['unavailable-icon']}></CgUnavailable>
                      {
                        ((duration == 15 || !bookingSlotAvailability)) ? <span className={styles['unavailable-span']}>Insufficient balance, please add amount to wallet.</span> :
                          <span className={styles['unavailable-span']}>Please add amount to wallet or select a shorter duration. </span>
                      }

                    </div>

                  }

                  {

                    (!bookingSlotAvailability || bookingSlotConflictShared) &&
                    <div>
                      <CgUnavailable className={styles['unavailable-icon']}></CgUnavailable>
                      <span className={styles['unavailable-span']}>Please change the duration or select another slot.</span>
                    </div>
                  }
                </div>
              }
              {
                (isBookingNonRes && !nonResBookingAllowed) &&
                <div className={styles["unavailable-container"]}>
                  <div>
                    <CgUnavailable className={styles['unavailable-icon']}></CgUnavailable>
                    <span className={styles['unavailable-span']}>Please enable auto pay or reload wallet.</span>
                  </div>
                </div>
              }


              {walletRechargeModal && <Modal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null}>
                {/* {console.log("amountToAdd", amountToAdd)} */}
                <StripePayment setWalletRechargeModal={setWalletRechargeModal} amountToAdd={amountToAdd} />
              </Modal>}

              {/* {
                phoneInputnModal && <Modal
                open={phoneInputnModal}
                onOk={()=>setShowPhoneVerificationModal(true)}
                onCancel={()=>setPhoneInputModal(false)}
                >

                  <input></input>
                </Modal>
              } */}

              {
                <PhoneVerificationModal
                  closeModal={() => setShowPhoneVerificationModal(false)}
                  onVerificationSuccess={handleVerificationSuccess}
                  modalVisible={showPhoneVerificationModal}
                  phoneNumber={phone}
                  fromBookingForm={true}
                  setPhoneState={setPhoneState}
                />
              }
              {guestPaymentBooking && <Modal title="Authorize Payment" open={!!guestPaymentBooking} onCancel={() => setGuestPaymentBooking(null)} footer={null} closable={false}>
                <GuestBookingPayment
                  amount={guestPaymentBooking.bookingData.estimateAmount}
                  onSuccess={(paymentIntentId) => {
                    const { bookingData, bookingCreatedAt } = guestPaymentBooking;
                    setGuestPaymentBooking(null);
                    submitBooking(bookingData, bookingCreatedAt, paymentIntentId);
                  }}
                  onCancel={() => setGuestPaymentBooking(null)}
                />
              </Modal>}

              {
                buttonElement
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
BookingForm.propTypes = {
  user: PropTypes.string,
  userID: PropTypes.string,
  userGroups: PropTypes.array,
  usersFreeChargingLocations: PropTypes.array,
  location: PropTypes.array,
  balance: PropTypes.number,
  isUserTester: PropTypes.bool,
  isAutoPayEnabled: PropTypes.bool,
  timeFormatAmPm: PropTypes.bool,
  isPhoneVerified: PropTypes.bool,
  phone: PropTypes.string,
  availableNightCharging: PropTypes.number,
  userAvgPower: PropTypes.object,
  userPreferredConnector: PropTypes.object,
  isGuest: PropTypes.bool,
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  location: state.auth && state.auth.user ? state.auth.user.location : null,
  usersFreeChargingLocations: state.auth && state.auth.user ? state.auth.user.freeChargingAllowedLocations : [],
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  isUserTester: state.auth && state.auth.user ? state.auth.user.isUserTester : false,
  isAutoPayEnabled: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
  isPhoneVerified: state.auth && state.auth.user ? state.auth.user.isPhoneVerified : false,
  phone: state.auth && state.auth.user ? state.auth.user.phone : false,
  availableNightCharging: state.auth && state.auth.user ? state.auth.user.availableNightCharging : 0,
  userAvgPower: state.auth && state.auth.user ? state.auth.user.avgPower : null,
  userPreferredConnector: state.auth && state.auth.user ? state.auth.user.preferredConnector : null,
  isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,
})
export default connect(mapStateToProps, {})(BookingForm)